<template>
    <div class="info">
        <svg
            id="svgP"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="600px"
            height="600px"
            viewBox="0 0 200 200"
            style="overflow:hidden!important;"
        >
            <defs id="SvgjsDefs1007">
                <radialGradient
                    id="SvgjsRadialGradient2904"
                    cx="100"
                    cy="114"
                    r="41"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-facehighlight-gradient-single-0"
                >
                    <stop
                        id="SvgjsStop2905"
                        stop-opacity="0.5"
                        stop-color="#ffe4d6"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop2906"
                        stop-opacity="0"
                        stop-color="#f0c7b1"
                        offset="0.9"
                    />
                </radialGradient>
                <radialGradient
                    id="SvgjsRadialGradient2908"
                    cx="100"
                    cy="54"
                    r="37"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-facehighlight-gradient-single-1"
                >
                    <stop
                        id="SvgjsStop2909"
                        stop-opacity="0.5"
                        stop-color="#ffe4d6"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop2910"
                        stop-opacity="0"
                        stop-color="#f0c7b1"
                        offset="0.9"
                    />
                </radialGradient>
                <radialGradient
                    id="SvgjsRadialGradient2946"
                    cx="-568.659"
                    cy="-521.042"
                    r="59.751"
                    gradientTransform="matrix(0.096 -0.0248 0.0245 0.0961 141.2814 119.9893)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesiris-gradient-left-1"
                >
                    <stop
                        id="SvgjsStop2947"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop2948"
                        stop-opacity="0"
                        stop-color="#ffffff"
                        offset="1"
                    />
                </radialGradient>
                <radialGradient
                    id="SvgjsRadialGradient2950"
                    cx="-582.838"
                    cy="-519.099"
                    r="59.745"
                    gradientTransform="matrix(0.0991 8.856319e-004 -0.0011 0.0991 131.1134 135.9855)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesiris-gradient-left-2"
                >
                    <stop
                        id="SvgjsStop2951"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop2952"
                        stop-opacity="0"
                        stop-color="#ffffff"
                        offset="1"
                    />
                </radialGradient>
                <linearGradient
                    id="SvgjsLinearGradient2956"
                    x1="122.67"
                    y1="88.268"
                    x2="123.606"
                    y2="87.152"
                    gradientTransform="matrix(1 0 0 1 -52 0)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesiris-gradient-left-5"
                >
                    <stop
                        id="SvgjsStop2957"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop2958"
                        stop-opacity="0"
                        stop-color="#ffffff"
                        offset="1"
                    />
                </linearGradient>
                <linearGradient
                    id="SvgjsLinearGradient2960"
                    x1="127.212"
                    y1="82.296"
                    x2="126.463"
                    y2="83.189"
                    gradientTransform="matrix(1 0 0 1 -52 0)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesiris-gradient-left-6"
                >
                    <stop
                        id="SvgjsStop2961"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop2962"
                        stop-opacity="0"
                        stop-color="#ffffff"
                        offset="1"
                    />
                </linearGradient>
                <linearGradient
                    id="SvgjsLinearGradient2964"
                    x1="129.636"
                    y1="79.822"
                    x2="127.91"
                    y2="81.879"
                    gradientTransform="matrix(1 0 0 1 -52 0)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesiris-gradient-left-7"
                >
                    <stop
                        id="SvgjsStop2965"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop2966"
                        stop-opacity="0"
                        stop-color="#ffffff"
                        offset="1"
                    />
                </linearGradient>
                <radialGradient
                    id="SvgjsRadialGradient2969"
                    cx="-568.654"
                    cy="-521.042"
                    r="59.752"
                    gradientTransform="matrix(0.096 -0.0248 0.0245 0.0961 193.2804 119.9894)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesiris-gradient-right-1"
                >
                    <stop
                        id="SvgjsStop2970"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop2971"
                        stop-opacity="0"
                        stop-color="#ffffff"
                        offset="1"
                    />
                </radialGradient>
                <radialGradient
                    id="SvgjsRadialGradient2973"
                    cx="-582.833"
                    cy="-519.102"
                    r="59.747"
                    gradientTransform="matrix(0.0991 8.856319e-004 -0.0011 0.0991 183.1126 135.9856)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesiris-gradient-right-2"
                >
                    <stop
                        id="SvgjsStop2974"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop2975"
                        stop-opacity="0"
                        stop-color="#ffffff"
                        offset="1"
                    />
                </radialGradient>
                <linearGradient
                    id="SvgjsLinearGradient2979"
                    x1="122.67"
                    y1="88.268"
                    x2="123.606"
                    y2="87.152"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesiris-gradient-right-5"
                >
                    <stop
                        id="SvgjsStop2980"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop2981"
                        stop-opacity="0"
                        stop-color="#ffffff"
                        offset="1"
                    />
                </linearGradient>
                <linearGradient
                    id="SvgjsLinearGradient2983"
                    x1="127.212"
                    y1="82.296"
                    x2="126.463"
                    y2="83.189"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesiris-gradient-right-6"
                >
                    <stop
                        id="SvgjsStop2984"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop2985"
                        stop-opacity="0"
                        stop-color="#ffffff"
                        offset="1"
                    />
                </linearGradient>
                <linearGradient
                    id="SvgjsLinearGradient2987"
                    x1="129.636"
                    y1="79.822"
                    x2="127.91"
                    y2="81.879"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesiris-gradient-right-7"
                >
                    <stop
                        id="SvgjsStop2988"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop2989"
                        stop-opacity="0"
                        stop-color="#ffffff"
                        offset="1"
                    />
                </linearGradient>
                <linearGradient
                    id="SvgjsLinearGradient3033"
                    x1="100"
                    y1="142"
                    x2="100"
                    y2="139"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-mouth-gradient-single-0"
                >
                    <stop
                        id="SvgjsStop3034"
                        stop-opacity="1"
                        stop-color="#e8b9a0"
                        offset="0.1"
                    />
                    <stop
                        id="SvgjsStop3035"
                        stop-opacity="1"
                        stop-color="#e1ac8f"
                        offset="1"
                    />
                </linearGradient>
                <linearGradient
                    id="SvgjsLinearGradient3906"
                    x1="100"
                    y1="171"
                    x2="100"
                    y2="131"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-chinshadow-gradient-single-0"
                >
                    <stop
                        id="SvgjsStop3907"
                        stop-opacity="0.8"
                        stop-color="#e1ac8f"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop3908"
                        stop-opacity="1"
                        stop-color="#c27b55"
                        offset="0.7"
                    />
                </linearGradient>
                <radialGradient
                    id="SvgjsRadialGradient3940"
                    cx="125.379"
                    cy="82.93"
                    r="12.84"
                    gradientTransform="matrix(-1.0592 4.000000e-004 -4.000000e-004 0.9318 206.5112 5.1767)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesback-gradient-left-0"
                >
                    <stop
                        id="SvgjsStop3941"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop3942"
                        stop-opacity="1"
                        stop-color="#fdfefe"
                        offset="0.544"
                    />
                    <stop
                        id="SvgjsStop3943"
                        stop-opacity="1"
                        stop-color="#f6f8f9"
                        offset="0.74"
                    />
                    <stop
                        id="SvgjsStop3944"
                        stop-opacity="1"
                        stop-color="#eaeff2"
                        offset="0.879"
                    />
                    <stop
                        id="SvgjsStop3945"
                        stop-opacity="1"
                        stop-color="#d9e3e8"
                        offset="0.992"
                    />
                    <stop
                        id="SvgjsStop3946"
                        stop-opacity="1"
                        stop-color="#d8e2e7"
                        offset="1"
                    />
                </radialGradient>
                <radialGradient
                    id="SvgjsRadialGradient3948"
                    cx="125.001"
                    cy="82.93"
                    r="12.841"
                    gradientTransform="matrix(1.0592 4.000000e-004 4.000000e-004 0.9318 -6.5112 5.1767)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesback-gradient-right-0"
                >
                    <stop
                        id="SvgjsStop3949"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop3950"
                        stop-opacity="1"
                        stop-color="#fdfefe"
                        offset="0.544"
                    />
                    <stop
                        id="SvgjsStop3951"
                        stop-opacity="1"
                        stop-color="#f6f8f9"
                        offset="0.74"
                    />
                    <stop
                        id="SvgjsStop3952"
                        stop-opacity="1"
                        stop-color="#eaeff2"
                        offset="0.879"
                    />
                    <stop
                        id="SvgjsStop3953"
                        stop-opacity="1"
                        stop-color="#d9e3e8"
                        offset="0.992"
                    />
                    <stop
                        id="SvgjsStop3954"
                        stop-opacity="1"
                        stop-color="#d8e2e7"
                        offset="1"
                    />
                </radialGradient>
                <radialGradient
                    id="SvgjsRadialGradient3956"
                    cx="125.379"
                    cy="82.93"
                    r="12.84"
                    gradientTransform="matrix(-1.0592 4.000000e-004 -4.000000e-004 0.9318 206.5112 5.1767)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesfront-gradient-left-0"
                >
                    <stop
                        id="SvgjsStop3957"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop3958"
                        stop-opacity="1"
                        stop-color="#fdfefe"
                        offset="0.544"
                    />
                    <stop
                        id="SvgjsStop3959"
                        stop-opacity="1"
                        stop-color="#f6f8f9"
                        offset="0.74"
                    />
                    <stop
                        id="SvgjsStop3960"
                        stop-opacity="1"
                        stop-color="#eaeff2"
                        offset="0.879"
                    />
                    <stop
                        id="SvgjsStop3961"
                        stop-opacity="1"
                        stop-color="#d9e3e8"
                        offset="0.992"
                    />
                    <stop
                        id="SvgjsStop3962"
                        stop-opacity="1"
                        stop-color="#d8e2e7"
                        offset="1"
                    />
                </radialGradient>
                <radialGradient
                    id="SvgjsRadialGradient3966"
                    cx="123.218"
                    cy="81.096"
                    fx="133.802"
                    fy="77.197"
                    r="17.898"
                    gradientTransform="matrix(0.9998 0.0183 0.0166 -0.7038 -47.7588 136.6255)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesfront-gradient-left-3"
                >
                    <stop
                        id="SvgjsStop3967"
                        stop-opacity="1"
                        stop-color="#e1ac8f"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop3968"
                        stop-opacity="0.3"
                        stop-color="#e1ac8f"
                        offset="0.7"
                    />
                    <stop
                        id="SvgjsStop3969"
                        stop-opacity="0"
                        stop-color="#f0c7b1"
                        offset="1"
                    />
                </radialGradient>
                <radialGradient
                    id="SvgjsRadialGradient3971"
                    cx="79.496"
                    cy="81.496"
                    r="23.208"
                    gradientTransform="matrix(1.0971 -0.0499 0.0576 0.9543 -20.1632 27.912)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesfront-gradient-left-4"
                >
                    <stop
                        id="SvgjsStop3972"
                        stop-opacity="0"
                        stop-color="#000000"
                        offset="0.9"
                    />
                    <stop
                        id="SvgjsStop3973"
                        stop-opacity="0.2"
                        stop-color="#000000"
                        offset="1"
                    />
                </radialGradient>
                <radialGradient
                    id="SvgjsRadialGradient3977"
                    cx="125.001"
                    cy="82.93"
                    r="12.841"
                    gradientTransform="matrix(1.0592 4.000000e-004 4.000000e-004 0.9318 -6.5112 5.1767)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesfront-gradient-right-0"
                >
                    <stop
                        id="SvgjsStop3978"
                        stop-opacity="1"
                        stop-color="#ffffff"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop3979"
                        stop-opacity="1"
                        stop-color="#fdfefe"
                        offset="0.544"
                    />
                    <stop
                        id="SvgjsStop3980"
                        stop-opacity="1"
                        stop-color="#f6f8f9"
                        offset="0.74"
                    />
                    <stop
                        id="SvgjsStop3981"
                        stop-opacity="1"
                        stop-color="#eaeff2"
                        offset="0.879"
                    />
                    <stop
                        id="SvgjsStop3982"
                        stop-opacity="1"
                        stop-color="#d9e3e8"
                        offset="0.992"
                    />
                    <stop
                        id="SvgjsStop3983"
                        stop-opacity="1"
                        stop-color="#d8e2e7"
                        offset="1"
                    />
                </radialGradient>
                <radialGradient
                    id="SvgjsRadialGradient3987"
                    cx="122.818"
                    cy="81.096"
                    fx="133.402"
                    fy="77.197"
                    r="17.898"
                    gradientTransform="matrix(-0.9998 0.0183 -0.0166 -0.7038 246.9601 136.6328)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesfront-gradient-right-3"
                >
                    <stop
                        id="SvgjsStop3988"
                        stop-opacity="1"
                        stop-color="#e1ac8f"
                        offset="0"
                    />
                    <stop
                        id="SvgjsStop3989"
                        stop-opacity="0.3"
                        stop-color="#e1ac8f"
                        offset="0.7"
                    />
                    <stop
                        id="SvgjsStop3990"
                        stop-opacity="0"
                        stop-color="#f0c7b1"
                        offset="1"
                    />
                </radialGradient>
                <radialGradient
                    id="SvgjsRadialGradient3992"
                    cx="79.859"
                    cy="81.511"
                    r="23.208"
                    gradientTransform="matrix(-1.0971 -0.0499 -0.0576 0.9543 220.163 27.9157)"
                    gradientUnits="userSpaceOnUse"
                    class="svga-on-canvas-eyesfront-gradient-right-4"
                >
                    <stop
                        id="SvgjsStop3993"
                        stop-opacity="0"
                        stop-color="#000000"
                        offset="0.9"
                    />
                    <stop
                        id="SvgjsStop3994"
                        stop-opacity="0.2"
                        stop-color="#000000"
                        offset="1"
                    />
                </radialGradient>
            </defs>
            <g id="svga-group-wrapper">
                <g id="svga-group-backs-single" />
                <g
                    id="svga-group-humanwrap-move"
                    transform="matrix(1,0,0,1,0,0)"
                >
                    <g
                        id="svga-group-humanwrap"
                        transform="matrix(0.8499995000000001,0,0,0.8499995000000001,14.979301542071454,16.39577637405489)"
                    >
                        <g
                            id="svga-group-hair-back-move"
                            transform="matrix(0.9999999999999998,1.7453294018365817e-9,-1.7453294018365817e-9,0.9999999999999998,2.617994425690995e-7,-1.7453291434321727e-7)"
                        >
                            <g
                                id="svga-group-hair-back"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <path
                                    id="SvgjsPath4010"
                                    d="M100.5,100.5h-1v-1h1V100.5z"
                                    fill="#3b3128"
                                    stroke-width="none"
                                    opacity="1"
                                />
                            </g>
                        </g>
                        <g id="svga-group-humanbody-single">
                            <path
                                id="SvgjsPath2911"
                                d="M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z"
                                fill="#f0c7b1"
                                stroke-width="none"
                                opacity="1"
                                stroke="none"
                            />
                            <path
                                id="SvgjsPath2912"
                                d="M159.156 184.058c24.342 3.542 34.586 8.708 37.794 50.721H200c0-12.5-0.877-26.992-4.583-35 -2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-18.242-12.069-21.643-16.35 3.36 4.704 12.791 15.605 21.054 18.46C150.188 182.61 153.48 183.232 159.156 184.058zM53.766 181.244c8.263-2.854 17.693-13.756 21.054-18.46 -3.4 4.28-16.114 15.054-21.643 16.35 -6.896 1.615-25.494 4.619-33.733 7.022 -6.665 1.942-12.664 8.876-14.86 13.622 -3.706 8.008-4.583 22.5-4.583 35h3.05c3.188-41.744 13.475-47.183 37.794-50.721C46.52 183.232 49.813 182.61 53.766 181.244z"
                                fill="#ffe4d6"
                                stroke-width="none"
                                opacity="1"
                                stroke="none"
                            />
                            <path
                                id="SvgjsPath2913"
                                d="M95.646 197.62c0 0-5.074-1.609-7.083-2.379 -10.449-4.009-44.395-6.607-44.395-6.607s35.754 1.419 43.644 2.779c-0.458-4.767-3.017-20.004-3.017-20.004s5.149 16.815 6.409 21.057C91.878 194.734 95.646 197.62 95.646 197.62zM106.445 196.278c-0.089 0.073-0.191 0.168-0.302 0.268C106.256 196.461 106.358 196.372 106.445 196.278zM95.646 197.62c0 0 2.893 2.992 4.347 3.03 1.91 0.051 4.828-2.899 6.151-4.104 -1.265 0.957-4.159 1.391-5.31 1.436C99.504 198.033 95.646 197.62 95.646 197.62zM116.664 190.101c-1.545 0.248-4.386 0.789-4.386 0.789l2.287-14.89c-0.646 3.071-4.474 16.211-8.12 20.278 1.91-1.616 6.158-2.391 8.324-2.704 10.236-1.484 10.232-1.483 41.062-4.94C155.831 188.634 126.76 188.479 116.664 190.101z"
                                fill="#e1ac8f"
                                stroke-width="none"
                                opacity="1"
                                stroke="none"
                            />
                            <path
                                id="SvgjsPath2914"
                                d="M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z"
                                fill="none"
                                stroke="#c27b55"
                                stroke-width="1.5"
                                opacity="1"
                            />
                        </g>
                        <g id="svga-group-chinshadow-single">
                            <path
                                id="SvgjsPath3905"
                                d="M100.021 171.866c8.183 0 16.871-4.943 24.199-10.675 -0.001-6.702 1.451-19.105 2.652-28.205 -15.382-2.247-38.406-2.279-53.766-0.152 1.184 8.96 2.625 21.206 2.671 28.02C83.119 166.767 91.822 171.866 100.021 171.866z"
                                fill="url(#SvgjsLinearGradient3906)"
                                opacity="1"
                            />
                        </g>
                        <g id="svga-group-clothes-single">
                            <path
                                id="SvgjsPath3928"
                                d="M128.857 237.978H70.72v-56.183c22.25 4.699 36.88 4.337 58.138 0V237.978z"
                                fill="#f3f1f3"
                                stroke-width="none"
                                opacity="1"
                            />
                            <path
                                id="SvgjsPath3929"
                                d="M107.44 237.709c-2.775 0-10.727 0.208-16.512-0.23l-0.01-0.171c-0.818-18.658 1.129-30.719 4.537-39.288l0.048-0.123 -0.093-0.093c-0.905-0.904-2.425-1.935-4.034-3.025 -1.611-1.093-3.275-2.221-4.336-3.246 0.625-0.732 1.395-1.454 2.348-2.201 0.245-0.125 1.162-0.843 5.974-4.971 0.214-0.184 0.345-0.296 0.362-0.31 0.818-0.178 2.138-0.293 3.738-0.293 2.183 0 4.731 0.221 6.512 0.563 1.561 1.458 3.451 5.329 4.158 7.17 -0.976 2.291-2.128 3.129-3.717 4.284 -0.774 0.563-1.652 1.201-2.652 2.112l-0.083 0.075 0.021 0.111c4.026 20.31 4.027 25.054 4.027 29.642 0.001 2.021 0.001 6.609 0.339 9.985C107.917 237.707 107.704 237.709 107.44 237.709z"
                                fill="#131111"
                                stroke-width="none"
                                opacity="1"
                            />
                            <path
                                id="SvgjsPath3930"
                                d="M110.35 191.495c-0.754-1.995-2.71-5.93-4.28-7.359 -2.876-0.563-7.983-0.843-10.47-0.24 -0.108 0.088-6.248 5.383-6.31 5.26 -0.906 0.708-1.788 1.504-2.52 2.39 2.061 2.076 6.655 4.556 8.5 6.4 -3.65 9.18-5.33 21.59-4.55 39.38 0.01 0.11 0.01 0.23 0.02 0.34 6.756 0.52 16.55 0.331 17.55 0.223 -1.16-11.307 1.438-10.455-4.39-39.853C106.968 195.241 108.865 195.04 110.35 191.495zM105.1 210.535c-0.021-0.05-0.04-0.1-0.051-0.13 2 10.55 1.38 18.632 2.891 26.972 -4.736-0.318-12.014-0.052-16.771-0.052 0.369-7.198 1.188-31.684 4.74-39.74 0.17-0.046 0.339-0.084 0.509-0.125l-1.032 34.736 2.747-35.066c0.02-0.002 0.04-0.005 0.06-0.008l1.801 32.605 0.417-32.734c0.026 0.001 0.051-0.001 0.077 0l4.199 36.355 -2.3-36.137c0.314 0.063 0.629 0.141 0.942 0.233 0.03 0 0.07 0.01 0.1 0.03C103.533 198.476 104.365 205.876 105.1 210.535zM104.219 196.726c-2.774-1.251-6.363-1.026-9.129 0.24 -1.681-1.813-4.08-3.077-7.53-5.391 0.55-0.479 1.26-1.07 2.21-1.81 0.08 0 3.48-2.771 3.54-2.83 0.92-0.84 1.74-1.79 2.52-2.62 2.93-0.12 7.23 0.02 9.82 0.14 1.5 1.876 2.931 4.696 4.01 6.94C107.699 194.266 105.759 195.545 104.219 196.726z"
                                fill="#000000"
                                stroke-width="none"
                                opacity="1"
                            />
                            <path
                                id="SvgjsPath3931"
                                d="M78.196 213.077c-11.534-40.071-6.325-29.581-9.399-45.32 2.028-4.813 3.958-10.44 5.042-11.598l0.08-0.086c2.292 24.007 8.958 13.636 23.784 27.722C89.228 189.449 81.372 204.127 78.196 213.077zM131.193 167.758c-1.448-3.702-4.077-9.127-5.215-10.331 1.424 20.678-15.146 16.551-24.35 26.2 8.812 5.713 17.173 20.66 20.172 29.455C134.92 169.568 127.85 188.673 131.193 167.758z"
                                fill="#f3f1f4"
                                stroke-width="none"
                                opacity="1"
                            />
                            <path
                                id="SvgjsPath3932"
                                d="M125.801 156.967c0 5.137-0.42 9.162-1.262 10.339 -2.443 5.809-13.103 9.853-16.39 11.51 -2.495 1.227-4.942 2.809-6.83 4.85 3.813 2.476 5.705 3.383 12.93 14.44 4.246 7.109 6.539 12.448 7.561 15.64 13.378-44.331 6.222-24.978 9.59-46.01C129.814 163.65 126.801 157.885 125.801 156.967zM129.449 176.495c-1.957 18.078-3.491 14.485-7.74 34.181 -2.716-8.644-11.075-22.913-19.43-27.091 3.937-2.957 5.031-3.131 9.729-5.279 14.396-6.42 14.985-12.385 14.138-20.271 1.207 1.423 3.125 6.161 4.692 9.521C129.979 170.702 129.589 175.194 129.449 176.495zM79.199 171.896c-4.408-3.649-3.16-8.162-5.189-16.215 -0.902 1-3.146 6.632-5.42 12.055 0.557 2.796 0.681 7.389 0.76 8.84 0.559 12.202 1.75 12.765 8.83 37.16 3.031-8.905 11.558-24.37 20.24-30.009C91.489 177.401 82.765 174.999 79.199 171.896zM84.659 197.405c-2.221 3.666-4.517 7.48-6.37 13.28 -4.442-20.269-5.999-16.964-7.73-34.16 -0.32-2.971-0.617-6.027-1.4-8.96 1.638-3.588 3.981-10.281 4.731-10.995 1.366 7.078 0.066 13.462 5.669 16.995 2.621 1.996 11.104 5.32 17.52 10.36C93.188 186.235 91.094 187.596 84.659 197.405z"
                                fill="#cfc8d7"
                                stroke-width="none"
                                opacity="1"
                            />
                            <path
                                id="SvgjsPath3933"
                                d="M120.319 209.824l-1.209-2.654c0 0 9.148-28.175 10.743-36.225C130.765 179.299 120.319 209.824 120.319 209.824zM78.879 208.721l1.436-3.259c0 0-8.573-26.467-10.168-34.517C69.235 179.299 78.879 208.721 78.879 208.721z"
                                fill="#e1e0e1"
                                stroke-width="none"
                                opacity="1"
                            />
                            <path
                                id="SvgjsPath3934"
                                d="M124.787 195.605c7.065-20.834 2.756-22.551 6.305-29.469 0.134-0.261 1.396 1.046 1.533 1.64 1.306 5.658 53.349 17.338 54.994 18.598 1.456 1.058 5.65 3.137 5.65 3.137 4.937 9.07 7.762 10.698 9.15 34.984 0.13 3.083-0.061 11.801-0.061 14.141l-85.559-0.676C117.004 230.169 117.999 216.15 124.787 195.605zM75.213 195.605c-7.065-20.834-2.756-22.551-6.305-29.469 -0.134-0.261-1.396 1.046-1.533 1.64 -1.306 5.658-53.349 17.338-54.994 18.598 -1.456 1.058-5.65 3.137-5.65 3.137 -4.937 9.07-7.762 10.698-9.15 34.984 -0.13 3.083 0.061 11.801 0.061 14.141l85.559-0.676C82.996 230.169 82.001 216.15 75.213 195.605z"
                                fill="#261818"
                                stroke-width="none"
                                opacity="1"
                                stroke="none"
                            />
                            <path
                                id="SvgjsPath3935"
                                d="M130.307 190c-4.552 16.387-10.771 31.116-13.506 47.96 -0.89-0.007 1.491-22.695 7.986-42.354 7.065-20.834 2.756-22.551 6.305-29.469 0.077-0.15-0.619 1.976-0.223 2.432C130.723 176.296 132.625 182.272 130.307 190zM69.693 190c4.552 16.387 10.771 31.116 13.506 47.96 0.89-0.007-1.491-22.695-7.986-42.354 -7.065-20.834-2.756-22.551-6.305-29.469 -0.077-0.15 0.619 1.976 0.223 2.432C69.277 176.296 67.375 182.272 69.693 190z"
                                fill="#170c0c"
                                stroke-width="none"
                                opacity="1"
                                stroke="none"
                            />
                            <path
                                id="SvgjsPath3936"
                                d="M152.436 186.031c0 0-2.284 2.561-8.636 6.923 5.313-5.885 7.761-8.249 7.761-8.249L152.436 186.031zM154.611 197.906l-1.528-1.367c-4.538 13.781-7.571 20.587-12.828 36.618C147.799 218.831 149.599 213.745 154.611 197.906zM48.439 184.705c0 0 2.447 2.364 7.761 8.249 -6.352-4.362-8.636-6.923-8.636-6.923L48.439 184.705zM59.745 233.157c-5.257-16.031-8.29-22.837-12.828-36.618l-1.528 1.367C50.401 213.745 52.201 218.831 59.745 233.157z"
                                fill="#070303"
                                stroke-width="none"
                                opacity="1"
                                stroke="none"
                            />
                            <path
                                id="SvgjsPath3937"
                                d="M179.409 219.335c0-11.596 3.11-18.351 9.615-28.142 0.608 0.372 0.931 0.543 1.345 0.875C183.452 200.651 182.078 208.659 179.409 219.335zM141.312 230.703c6.113-16.703 8.06-23.228 12.107-34.388 -1.15-0.351-8.671-2.985-9.819-3.346 0.41 1 3.113 1.822 7.822 4.709C151.422 197.679 146.333 213.082 141.312 230.703zM149.533 184.577c0 0-3.352 4.14-6.664 8.328 3.388-2.67 5.748-5.644 8.691-8.2 -3.994-3.368-10.511-8.524-14.721-12.089C140.163 176.188 149.533 184.577 149.533 184.577zM202.073 238.634l0.286 0.002c0-2.34 0.19-11.058 0.061-14.141 -1.389-24.286-4.214-25.914-9.15-34.984 0 0-4.194-2.079-5.65-3.137 -1.334-1.021-38.794-9.922-52.49-15.88 16.011 10.971 46.282 15.027 55.24 21.574C194.702 195.235 200.535 222.337 202.073 238.634zM9.613 192.037c0.542-0.383 0.619-0.366 1.168-0.729 6.505 9.791 9.809 16.431 9.809 28.026C17.922 208.659 16.08 200.318 9.613 192.037zM48.578 197.679c4.709-2.887 7.412-3.709 7.822-4.709 -1.148 0.36-8.669 2.995-9.819 3.346 4.048 11.16 5.994 17.685 12.107 34.388C53.667 213.082 48.578 197.679 48.578 197.679zM63.16 172.616c-4.21 3.564-10.727 8.721-14.721 12.089 2.943 2.557 5.304 5.53 8.691 8.2 -3.313-4.188-6.664-8.328-6.664-8.328S59.837 176.188 63.16 172.616zM9.631 192.068c8.958-6.547 39.229-10.604 55.24-21.574 -13.696 5.958-51.156 14.858-52.49 15.88 -1.456 1.058-5.65 3.137-5.65 3.137 -4.937 9.07-7.762 10.698-9.15 34.984 -0.13 3.083 0.061 11.801 0.061 14.141l0.286-0.002C-0.535 222.337 5.298 195.235 9.631 192.068z"
                                fill="#352727"
                                stroke-width="none"
                                opacity="1"
                                stroke="none"
                            />
                            <path
                                id="SvgjsPath3938"
                                d="M132.246 166.374c-0.049-0.293-0.443-0.634-0.738-0.657 -0.296-0.023-0.432 0.458-0.567 0.722 -3.549 6.918 0.414 8.333-6.651 29.167 -6.788 20.545-7.584 34.862-7.787 42.653l85.857 0.377c0-2.34 0.489-11.058 0.359-14.141 -1.389-24.286-4.313-26.113-9.25-35.184 0 0-4.394-2.179-5.85-3.236 -4.889-3.742-0.59 0.023-22.03-6 -17.576-5.135-18.525-6.577-24.899-8.35 -1.288-0.369-4.057-0.822-6.95-2.851C133.475 168.689 132.341 166.944 132.246 166.374zM116.974 237.31c3.729-23.564 6.085-29.73 11.296-47.274 3.522-11.104 1.576-17.408 3.254-22.54 0.088-0.268 0.467-0.282 0.571-0.017 2.434 6.214 9.238 7.656 18.834 17.047 -5.813 5.813-7.309 7.38-8.06 8.38 0.864 0.438 5.582 2.229 9.9 3.9 -0.245 0.767-13.415 38.02-13.57 38.52 10-21.578 11.292-28.211 14.22-39.01 -0.812-0.612-7.892-3.212-9.09-3.64 4.274-4.424 5.51-5.396 7.53-7.971 1.622 0-15.874-13.318-16.73-14.211 0.462 0.364 2.752 1.391 3.01 1.491 14.682 5.166 3.065 2.829 35.2 12.001 3.072 0.781 7.355 1.567 10.53 1.879 0.218 0.02 5.395 2.727 8.35 3.97 -7.189 7.475-11.797 17.133-12.81 29.5 3.219-12.666 4.951-19.29 13.14-28.819 7.62 15.422 6.755 13.195 9.23 47.71C181.167 237.413 149.559 237.227 116.974 237.31zM66.261 168.875c-2.894 2.028-5.662 2.481-6.95 2.851 -6.374 1.772-7.323 3.215-24.899 8.35 -21.44 6.023-17.142 2.258-22.03 6 -1.456 1.058-5.85 3.236-5.85 3.236 -4.937 9.07-7.861 10.897-9.25 35.184 -0.13 3.083 0.359 11.801 0.359 14.141l85.857-0.377c-0.203-7.791-0.999-22.108-7.787-42.653 -7.065-20.834-3.103-22.249-6.651-29.167 -0.136-0.264-0.271-0.745-0.567-0.722 -0.295 0.023-0.689 0.364-0.738 0.657C67.659 166.944 66.525 168.689 66.261 168.875zM-1.779 238.226c2.476-34.515 1.61-32.288 9.23-47.71 8.188 9.529 9.921 16.153 13.14 28.819 -1.013-12.367-5.62-22.025-12.81-29.5 2.955-1.243 8.132-3.95 8.35-3.97 3.175-0.312 7.458-1.098 10.53-1.879 32.135-9.172 20.519-6.835 35.2-12.001 0.258-0.101 2.548-1.127 3.01-1.491 -0.856 0.893-18.353 14.211-16.73 14.211 2.021 2.575 3.256 3.547 7.53 7.971 -1.198 0.428-8.278 3.027-9.09 3.64 2.928 10.799 4.22 17.432 14.22 39.01 -0.155-0.5-13.325-37.753-13.57-38.52 4.318-1.672 9.036-3.463 9.9-3.9 -0.751-1-2.247-2.567-8.06-8.38 9.596-9.391 16.4-10.833 18.834-17.047 0.104-0.266 0.483-0.251 0.571 0.017 1.678 5.132-0.269 11.436 3.254 22.54 5.211 17.544 7.567 23.71 11.296 47.274C50.441 237.227 18.833 237.413-1.779 238.226z"
                                fill="#000000"
                                stroke-width="none"
                                opacity="1"
                                stroke="none"
                            />
                        </g>
                        <!-- head -->
                        <g id="svga-group-head" transform="rotate(0 120 140)">
                            <g
                                id="svga-group-ears-left-move"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <g
                                    id="svga-group-ears-left"
                                    transform="matrix(1,0,0,1,0,0)"
                                >
                                    <path
                                        id="SvgjsPath2924"
                                        d="M45.671 84.344c-1.485-2.462-6.327-9.199-10.031-8.254 -3.012 0.772-2.973 4.971-3.206 7.455 -0.34 3.644-0.464 9.992 0.525 12.568 0.951 2.473 3.96 7.252 5.828 9.075 2.299 2.235 5.97 9.358 6.422 10.097 0.711 1.168 2.137 2.84 4.325 2.708 3.071-0.185 5.724-3.087 5.965-4.485C56.8 105.918 49.536 90.75 45.671 84.344z"
                                        fill="#f0c7b1"
                                        stroke="#c27b55"
                                        stroke-width="1.5"
                                        opacity="1"
                                    />
                                    <path
                                        id="SvgjsPath2925"
                                        d="M44.2 99.341c-0.143-0.563 0.007-1.513 0.154-2.429 0.133-0.835 0.258-1.624 0.182-2.182 -0.289-2.09-1.915-6.06-2.976-8.212 -1.223-2.476-3.199-5.595-5.679-6.399 -1.024-0.333-1.699 0.065-2.089 0.468 -0.288 0.296-0.353 0.645-0.259 0.687 0.095 0.041 0.307-0.248 0.617-0.519 0.254-0.222-0.508-0.04 0 0 -0.205 1.04-0.865 6.302-0.41 10.143 0.358 3.022 1.05 5.279 1.263 5.617 0.031 0.356 0.083 0.705 0.16 1.043 1.002 4.41 7.518 10.177 9.034 11.82 0.28 0.303 0.574 0.483 0.646 0.409s-0.101-0.373-0.379-0.678c-1.498-1.632-7.971-7.381-8.939-11.635 -1.027-4.514 3.912-11.207 4.699-12.623 0.401 0.665 0.742 1.303 1.004 1.835 0.207 0.417 0.434 0.906 0.67 1.435 -0.463 0.738-5.118 6.127-3.934 10.441 0.438 1.591 3.822 3.642 5.131 4.203 0.72 0.31 0.99 0.772 1.304 1.306 0.364 0.624 0.033 2.229 1.23 2.739 0.244 0.104 0.464 0.146 0.659 0.146 0.338 0 0.594-0.13 0.783-0.284 0.02 0.271 0.019 0.619 0.009 0.941 -0.012 0.418 0.047 0.609 0.148 0.617 0.103 0.009 0.21-0.174 0.223-0.587 0.017-0.51 0.014-1.141-0.077-1.444 -0.269-0.889-1.088-1.894-1.957-2.957C44.563 102.197 44.422 100.213 44.2 99.341zM34.969 95.432c-2.348-6.923 1.283-13.229 1.81-14.179 1.012 0.399 2.562 2.193 3.221 3.235C39.52 85.321 35.067 90.775 34.969 95.432zM45.772 106.464c-1.084-0.462-0.706-1.984-1.056-2.584 -0.318-0.542-0.646-1.102-1.479-1.46 -0.18-0.078-0.379-0.196-0.583-0.332 -2.682-6.075 0.293-8.73 1.039-9.273 0.229 0.742 0.399 1.423 0.476 1.97 0.068 0.5-0.059 1.298-0.181 2.068 -0.153 0.955-0.31 1.944-0.147 2.584 0.244 0.953 0.411 2.97 1.291 4.048 0.781 0.956 1.583 1.942 1.857 2.746C46.871 106.391 46.5 106.775 45.772 106.464z"
                                        fill="#c27b55"
                                        stroke-width="none"
                                        opacity="1"
                                        stroke="none"
                                    />
                                </g>
                            </g>
                            <g
                                id="svga-group-ears-right-move"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <g
                                    id="svga-group-ears-right"
                                    transform="matrix(1,0,0,1,0,0)"
                                >
                                    <path
                                        id="SvgjsPath2926"
                                        d="M154.066 84.344c1.486-2.462 6.328-9.199 10.031-8.254 3.012 0.772 2.973 4.971 3.207 7.455 0.34 3.644 0.463 9.992-0.525 12.568 -0.951 2.473-3.961 7.252-5.828 9.075 -2.299 2.235-5.971 9.358-6.422 10.097 -0.711 1.168-2.137 2.84-4.326 2.708 -3.07-0.185-5.723-3.087-5.965-4.485C142.938 105.918 150.203 90.75 154.066 84.344z"
                                        fill="#f0c7b1"
                                        stroke="#c27b55"
                                        stroke-width="1.5"
                                        opacity="1"
                                    />
                                    <path
                                        id="SvgjsPath2927"
                                        d="M154.322 103.243c-0.869 1.063-1.688 2.068-1.957 2.957 -0.092 0.304-0.094 0.935-0.078 1.444 0.014 0.413 0.121 0.596 0.225 0.587 0.102-0.008 0.16-0.199 0.148-0.617 -0.01-0.322-0.012-0.67 0.008-0.941 0.189 0.154 0.445 0.284 0.783 0.284 0.195 0 0.416-0.042 0.66-0.146 1.195-0.511 0.865-2.116 1.229-2.739 0.314-0.534 0.584-0.997 1.305-1.306 1.309-0.561 4.693-2.611 5.131-4.203 1.184-4.314-3.471-9.704-3.934-10.441 0.234-0.529 0.463-1.018 0.668-1.435 0.264-0.532 0.604-1.171 1.006-1.835 0.787 1.416 5.725 8.108 4.699 12.623 -0.969 4.254-7.441 10.003-8.939 11.635 -0.279 0.305-0.453 0.604-0.381 0.678 0.074 0.074 0.367-0.106 0.646-0.409 1.516-1.643 8.031-7.41 9.033-11.82 0.078-0.338 0.131-0.687 0.162-1.043 0.211-0.337 0.904-2.594 1.262-5.617 0.455-3.841-0.205-9.103-0.41-10.143 0.508-0.04-0.254-0.222 0 0 0.311 0.271 0.523 0.56 0.617 0.519 0.094-0.042 0.029-0.39-0.258-0.687 -0.391-0.403-1.066-0.801-2.09-0.468 -2.48 0.804-4.457 3.923-5.68 6.399 -1.061 2.152-2.686 6.122-2.975 8.212 -0.076 0.558 0.049 1.347 0.182 2.182 0.146 0.916 0.297 1.866 0.154 2.429C155.316 100.213 155.176 102.197 154.322 103.243zM159.738 84.488c0.66-1.042 2.209-2.835 3.221-3.235 0.527 0.95 4.158 7.256 1.811 14.179C164.672 90.775 160.219 85.321 159.738 84.488zM152.75 106.229c0.273-0.804 1.076-1.79 1.857-2.746 0.879-1.078 1.047-3.095 1.291-4.048 0.162-0.64 0.006-1.629-0.146-2.584 -0.123-0.77-0.25-1.568-0.182-2.068 0.076-0.547 0.246-1.228 0.475-1.97 0.746 0.543 3.721 3.199 1.039 9.273 -0.203 0.136-0.402 0.254-0.584 0.332 -0.832 0.358-1.16 0.918-1.479 1.46 -0.35 0.6 0.029 2.123-1.055 2.584C153.238 106.775 152.867 106.391 152.75 106.229z"
                                        fill="#c27b55"
                                        stroke-width="none"
                                        opacity="1"
                                        stroke="none"
                                    />
                                </g>
                            </g>
                            <g
                                id="svga-group-faceshape-wrap"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <g id="svga-group-faceshape-single">
                                    <path
                                        id="SvgjsPath3902"
                                        d="M158.785 78.006l-0.005 0c-0.01 0.046-12.197 40.27-15.879 52.418 -0.715 2.358-1.931 4.551-3.556 6.386 -6.375 7.194-23.768 25.057-39.324 25.057 -15.849 0-33.591-19.045-39.708-26.214 -1.442-1.688-2.507-3.633-3.172-5.765 -3.607-11.551-16.126-51.648-16.137-51.694h-0.001c-1.298-4.992-1.994-10.231-2.002-15.634C38.949 28.536 66.155 0.92 99.773 0.867c33.621-0.053 60.913 27.476 60.964 61.499C160.746 67.769 160.068 73.01 158.785 78.006z"
                                        fill="#f0c7b1"
                                        stroke-width="none"
                                        opacity="1"
                                    />
                                    <path
                                        id="SvgjsPath3903"
                                        d="M132.168 10.26c14.31 11.135 23.671 29.457 23.699 50.208 0.009 5.404-0.615 10.645-1.796 15.641l-0.004 0c-0.009 0.046-11.223 40.27-14.608 52.417 -0.658 2.358-1.776 4.551-3.271 6.385 -5.865 7.195-21.866 25.059-36.178 25.059 -14.582 0-30.904-19.047-36.531-26.215 -1.327-1.689-2.306-3.633-2.918-5.764 -3.318-11.552-14.836-51.649-14.846-51.695h-0.001c-1.194-4.992-1.834-10.231-1.842-15.634 -0.029-20.827 9.348-39.239 23.713-50.412C50.392 21.159 38.967 40.508 39.001 62.56c0.008 5.403 0.704 10.643 2.002 15.634h0.001c0.01 0.046 12.53 40.143 16.137 51.694 0.666 2.132 1.73 4.076 3.172 5.765 6.116 7.169 23.858 26.214 39.708 26.214 15.557 0 32.949-17.862 39.324-25.057 1.625-1.835 2.841-4.027 3.556-6.386 3.682-12.148 15.869-52.372 15.879-52.418l0.005 0c1.283-4.997 1.961-10.237 1.952-15.641C160.704 40.389 149.297 21.135 132.168 10.26z"
                                        fill="#e8b9a0"
                                        stroke-width="none"
                                        opacity="1"
                                    />
                                    <path
                                        id="SvgjsPath3904"
                                        d="M158.785 78.006l-0.005 0c-0.01 0.046-12.197 40.27-15.879 52.418 -0.715 2.358-1.931 4.551-3.556 6.386 -6.375 7.194-23.768 25.057-39.324 25.057 -15.849 0-33.591-19.045-39.708-26.214 -1.442-1.688-2.507-3.633-3.172-5.765 -3.607-11.551-16.126-51.648-16.137-51.694h-0.001c-1.298-4.992-1.994-10.231-2.002-15.634C38.949 28.536 66.155 0.92 99.773 0.867c33.621-0.053 60.913 27.476 60.964 61.499C160.746 67.769 160.068 73.01 158.785 78.006z"
                                        fill="none"
                                        stroke="#c27b55"
                                        stroke-width="1.5"
                                        opacity="1"
                                    />
                                </g>
                            </g>
                            <g
                                id="svga-group-mouth-single-move"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <g
                                    id="svga-group-mouth-single"
                                    transform="matrix(1,0,0,1,0,0)"
                                >
                                    <path
                                        id="SvgjsPath3032"
                                        d="M96.227 139.237l8.297-0.207C103.563 143.5 96.884 142.858 96.227 139.237z"
                                        fill="url(#SvgjsLinearGradient3033)"
                                        opacity="1"
                                    />
                                    <path
                                        id="SvgjsPath3036"
                                        d="M96.343 139.52c-0.371-0.05-0.315-0.579 0.08-0.542 0.043 0.006 4.308 0.546 7.878-0.215 0.386-0.075 0.5 0.455 0.13 0.534C101.634 139.895 98.015 139.755 96.343 139.52zM100.083 135.95c-1.503 0-2.96-0.521-4.424-0.776 -1.64-0.287-3.274-0.041-4.915 0.104 -1.676 0.149-5.333-0.013-6.365-0.666 -0.578-0.367-0.47-1.221 0.181-1.449 0.614-0.22 1.571 0.236 2.191 0.347 2.872 0.515 4.384-0.034 6.902-0.118 3.851-0.116 4.26 1.501 9.064 0.53 5.165-1.044 7.491-0.254 11.197-1.37 0.508-0.154 1.112-0.56 1.645-0.286 0.615 0.318 0.585 1.185-0.049 1.464 -3.406 1.502-7.174 0.895-10.955 1.526C103.073 135.502 101.596 135.95 100.083 135.95z"
                                        fill="#c27b55"
                                        stroke-width="none"
                                        opacity="1"
                                        stroke="none"
                                    />
                                </g>
                            </g>
                            <g
                                id="svga-group-eyes-left-move"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <g
                                    id="svga-group-eyes-left"
                                    transform="matrix(1,0,0,1,0,0)"
                                >
                                    <g id="svga-group-eyesback-left">
                                        <path
                                            id="SvgjsPath3939"
                                            d="M83.071 89.125c-3.293-0.784-4.969 1.059-9.809 1.166 -8.057 0.177-9.938-0.618-11.199-2.638 -0.523-0.837-1.023-1.928-1.264-2.601l-0.1-4.149c1.328-3.949 19.541-4.352 25.9 1.784 0.287 0.666 0.433 1.287 0.465 1.867 -0.19 0.958-0.512 1.878-0.947 2.749C85.411 88.113 84.355 88.729 83.071 89.125z"
                                            fill="url(#SvgjsRadialGradient3940)"
                                            opacity="1"
                                        />
                                    </g>
                                    <g
                                        id="svga-group-eyesiriswrapper-left"
                                        transform="matrix(1,0,0,1,0.25,0.25)"
                                    >
                                        <g
                                            id="svga-group-eyesiriscontrol-left"
                                            transform="matrix(1,0,0,1,0,0)"
                                        >
                                            <g
                                                id="svga-group-eyesiris-left"
                                                transform="matrix(1,0,0,1,0,0)"
                                            >
                                                <path
                                                    id="SvgjsPath2944"
                                                    d="M80 84c0 3.313-2.687 6-6 6 -3.313 0-6-2.687-6-6l0 0c0-3.314 2.687-6 6-6C77.313 77.999 80 80.686 80 84L80 84z"
                                                    fill="#4e60a3"
                                                    stroke-width="none"
                                                    opacity="1"
                                                />
                                                <path
                                                    id="SvgjsPath2945"
                                                    d="M73.328 78.066c-0.023 0.003-0.047 0.006-0.071 0.009 0.029 0.135 0.057 0.271 0.085 0.406C73.336 78.344 73.333 78.204 73.328 78.066zM73.341 78.48c0.07 1.972 0.185 3.729 0.517 4.364C74.033 82.148 73.735 80.414 73.341 78.48zM73.859 82.845c-0.043 0.167-0.108 0.281-0.208 0.319 -0.1 0.038-0.226-0.006-0.368-0.103 0.041 0.167 0.037 0.297-0.036 0.378 -0.072 0.081-0.201 0.101-0.373 0.078 0.113 0.13 0.171 0.249 0.146 0.353 -0.027 0.104-0.134 0.182-0.293 0.242 0.159 0.063 0.266 0.141 0.291 0.245 0.025 0.104-0.033 0.223-0.145 0.352 0.17-0.021 0.301 0.001 0.371 0.082 0.071 0.081 0.075 0.212 0.035 0.379 0.141-0.097 0.265-0.139 0.365-0.1 0.101 0.038 0.166 0.152 0.206 0.32 0.081-0.152 0.171-0.249 0.28-0.26 0.104-0.014 0.216 0.059 0.329 0.188 0.001-0.172 0.037-0.299 0.127-0.36 0.088-0.061 0.219-0.049 0.379 0.013 -0.078-0.152-0.105-0.281-0.055-0.377 0.05-0.095 0.173-0.146 0.344-0.166 -0.141-0.099-0.227-0.2-0.225-0.308 0-0.108 0.084-0.209 0.227-0.306 -0.17-0.021-0.291-0.072-0.342-0.167 -0.049-0.095-0.022-0.225 0.058-0.377 -0.162 0.06-0.292 0.072-0.38 0.011 -0.089-0.061-0.125-0.188-0.125-0.36 -0.112 0.128-0.224 0.199-0.33 0.185C74.029 83.092 73.938 82.998 73.859 82.845zM74.466 82.92c0.479-0.535 1.021-2.209 1.57-4.104C75.182 80.593 74.467 82.202 74.466 82.92zM76.035 78.816c0.06-0.122 0.121-0.246 0.178-0.37 -0.021-0.007-0.042-0.017-0.063-0.026C76.112 78.553 76.074 78.686 76.035 78.816zM74.972 83.27c0.672-0.252 1.931-1.483 3.297-2.905C76.688 81.541 75.306 82.634 74.972 83.27zM78.269 80.365c0.1-0.075 0.203-0.15 0.305-0.225 -0.014-0.018-0.03-0.033-0.042-0.049C78.445 80.181 78.358 80.274 78.269 80.365zM75.254 83.814c0.713 0.088 2.4-0.417 4.272-1.041C77.578 83.081 75.848 83.406 75.254 83.814zM79.526 82.774c0.11-0.016 0.225-0.034 0.337-0.052 -0.004-0.019-0.009-0.038-0.014-0.057C79.742 82.701 79.632 82.738 79.526 82.774zM75.253 84.427c0.59 0.412 2.318 0.747 4.262 1.063C77.65 84.857 75.967 84.342 75.253 84.427zM79.516 85.49c0.095 0.033 0.191 0.067 0.285 0.098 0.005-0.017 0.009-0.033 0.012-0.05C79.716 85.523 79.615 85.507 79.516 85.49zM74.965 84.97c0.333 0.637 1.708 1.738 3.282 2.924C76.888 86.464 75.638 85.226 74.965 84.97zM78.248 87.892c0.059 0.062 0.12 0.126 0.179 0.189 0.01-0.012 0.019-0.021 0.03-0.032C78.387 87.997 78.315 87.944 78.248 87.892zM74.46 85.317c-0.003 0.719 0.703 2.331 1.547 4.113C75.468 87.533 74.937 85.855 74.46 85.317zM76.007 89.431c0.021 0.075 0.043 0.152 0.063 0.229 0.015-0.006 0.025-0.01 0.039-0.014C76.076 89.574 76.041 89.5 76.007 89.431zM73.851 85.389c-0.336 0.637-0.461 2.39-0.542 4.361C73.713 87.82 74.022 86.087 73.851 85.389zM73.309 89.75c-0.017 0.075-0.031 0.151-0.047 0.228 0.014 0.003 0.025 0.003 0.039 0.005C73.303 89.906 73.307 89.826 73.309 89.75zM73.28 85.169c-0.596 0.407-1.521 1.904-2.508 3.61C72.026 87.259 73.106 85.867 73.28 85.169zM70.772 88.779c-0.053 0.063-0.108 0.13-0.162 0.193 0.013 0.008 0.024 0.014 0.038 0.024C70.688 88.924 70.731 88.851 70.772 88.779zM72.875 84.71c-0.716 0.083-2.231 0.978-3.898 2.029C70.795 85.977 72.395 85.248 72.875 84.71zM68.976 86.741c-0.086 0.036-0.174 0.072-0.263 0.11 0.006 0.013 0.015 0.027 0.023 0.04C68.817 86.842 68.897 86.791 68.976 86.741zM72.728 84.113c-0.671-0.257-2.429-0.168-4.395-0.011C70.297 84.27 72.055 84.367 72.728 84.113zM68.333 84.102c-0.107-0.01-0.217-0.02-0.323-0.029 0 0.019-0.002 0.038 0 0.056C68.119 84.119 68.228 84.11 68.333 84.102zM72.875 83.519c-0.473-0.539-2.069-1.277-3.881-2.051C70.653 82.528 72.163 83.432 72.875 83.519zM68.994 81.468c-0.104-0.067-0.209-0.134-0.315-0.201 -0.009 0.019-0.019 0.038-0.029 0.055C68.766 81.371 68.882 81.419 68.994 81.468zM73.284 83.061c-0.169-0.698-1.241-2.094-2.485-3.623C71.775 81.15 72.692 82.651 73.284 83.061zM70.799 79.438c-0.067-0.115-0.132-0.232-0.199-0.349 -0.019 0.013-0.039 0.026-0.056 0.039C70.628 79.231 70.716 79.335 70.799 79.438z"
                                                    fill="url(#SvgjsRadialGradient2946)"
                                                    opacity="0.7"
                                                />
                                                <path
                                                    id="SvgjsPath2949"
                                                    d="M74.886 78.086c-0.024-0.003-0.047-0.007-0.07-0.01 -0.007 0.138-0.016 0.277-0.024 0.414C74.822 78.356 74.855 78.22 74.886 78.086zM74.791 78.489c-0.442 1.922-0.787 3.649-0.629 4.35C74.511 82.211 74.671 80.459 74.791 78.489zM74.161 82.839c-0.084 0.15-0.176 0.243-0.283 0.254 -0.106 0.01-0.216-0.064-0.327-0.195 -0.004 0.171-0.042 0.297-0.133 0.356 -0.09 0.059-0.221 0.045-0.38-0.021 0.076 0.155 0.101 0.285 0.049 0.378 -0.053 0.094-0.176 0.142-0.345 0.158 0.137 0.101 0.22 0.204 0.217 0.312 -0.002 0.107-0.089 0.207-0.231 0.302 0.169 0.024 0.29 0.079 0.337 0.174 0.048 0.096 0.018 0.225-0.064 0.375 0.161-0.057 0.292-0.065 0.379-0.002 0.087 0.063 0.12 0.19 0.116 0.363 0.117-0.125 0.229-0.196 0.337-0.179 0.105 0.014 0.194 0.113 0.27 0.268 0.045-0.167 0.113-0.279 0.216-0.315 0.101-0.036 0.225 0.01 0.363 0.111 -0.036-0.167-0.029-0.299 0.044-0.378 0.073-0.079 0.205-0.096 0.376-0.072 -0.111-0.132-0.168-0.251-0.138-0.355 0.028-0.104 0.136-0.18 0.299-0.237 -0.16-0.064-0.263-0.145-0.288-0.25 -0.023-0.105 0.037-0.223 0.154-0.349 -0.172 0.016-0.301-0.006-0.37-0.088 -0.07-0.082-0.072-0.214-0.028-0.379 -0.142 0.094-0.268 0.134-0.367 0.093C74.261 83.122 74.199 83.007 74.161 82.839zM74.729 83.07c0.601-0.394 1.557-1.871 2.578-3.558C76.022 81.007 74.916 82.375 74.729 83.07zM77.307 79.511c0.089-0.102 0.18-0.206 0.268-0.311 -0.019-0.013-0.036-0.028-0.055-0.042C77.449 79.277 77.378 79.396 77.307 79.511zM75.127 83.538c0.715-0.07 2.25-0.934 3.937-1.953C77.231 82.312 75.614 83.01 75.127 83.538zM79.063 81.584c0.117-0.046 0.235-0.092 0.354-0.138 -0.01-0.021-0.021-0.04-0.028-0.059C79.281 81.453 79.173 81.52 79.063 81.584zM75.259 84.137c0.666 0.27 2.426 0.218 4.395 0.101C77.693 84.03 75.938 83.896 75.259 84.137zM79.654 84.237c0.112 0.013 0.226 0.025 0.339 0.037 0-0.02 0.001-0.039 0.002-0.058C79.881 84.223 79.766 84.23 79.654 84.237zM75.1 84.729c0.462 0.551 2.046 1.321 3.842 2.129C77.303 85.763 75.811 84.831 75.1 84.729zM78.941 86.858c0.083 0.057 0.167 0.114 0.25 0.168 0.009-0.015 0.017-0.03 0.025-0.045C79.126 86.942 79.032 86.9 78.941 86.858zM74.68 85.179c0.156 0.701 1.2 2.12 2.414 3.674C76.151 87.119 75.264 85.599 74.68 85.179zM77.094 88.85c0.042 0.075 0.083 0.153 0.125 0.229 0.012-0.009 0.024-0.016 0.037-0.024C77.202 88.987 77.147 88.917 77.094 88.85zM74.103 85.383c-0.188 0.693 0.076 2.433 0.43 4.373C74.502 87.784 74.424 86.026 74.103 85.383zM74.532 89.756c0.001 0.078 0.003 0.158 0.003 0.238 0.014-0.002 0.027-0.004 0.041-0.004C74.562 89.913 74.547 89.833 74.532 89.756zM73.496 85.294c-0.49 0.528-1.064 2.189-1.652 4.072C72.733 87.607 73.481 86.013 73.496 85.294zM71.843 89.366c-0.035 0.068-0.07 0.138-0.104 0.208 0.012 0.006 0.023 0.009 0.036 0.015C71.797 89.516 71.821 89.439 71.843 89.366zM73 84.934c-0.68 0.239-1.962 1.446-3.357 2.838C71.25 86.628 72.652 85.563 73 84.934zM69.644 87.772c-0.067 0.047-0.137 0.098-0.205 0.145 0.01 0.011 0.02 0.02 0.029 0.032C69.525 87.89 69.585 87.832 69.644 87.772zM72.728 84.385c-0.713-0.104-2.407 0.368-4.291 0.952C70.392 85.071 72.125 84.781 72.728 84.385zM68.437 85.339c-0.092 0.013-0.187 0.024-0.283 0.039 0.003 0.015 0.008 0.03 0.013 0.044C68.258 85.396 68.348 85.366 68.437 85.339zM72.741 83.772c-0.582-0.423-2.303-0.792-4.242-1.149C70.353 83.294 72.025 83.843 72.741 83.772zM68.499 82.623c-0.101-0.037-0.205-0.075-0.305-0.112 -0.005 0.019-0.011 0.037-0.015 0.054C68.288 82.584 68.395 82.604 68.499 82.623zM73.038 83.235c-0.318-0.643-1.668-1.769-3.219-2.986C71.147 81.704 72.372 82.968 73.038 83.235zM69.818 80.25c-0.083-0.091-0.167-0.183-0.251-0.275 -0.014 0.016-0.029 0.031-0.042 0.046C69.624 80.097 69.723 80.173 69.818 80.25zM73.551 82.899c0.017-0.718-0.656-2.344-1.464-4.142C72.587 80.663 73.085 82.35 73.551 82.899zM72.087 78.757c-0.034-0.128-0.067-0.259-0.101-0.389 -0.021 0.007-0.043 0.015-0.063 0.023C71.977 78.513 72.033 78.636 72.087 78.757z"
                                                    fill="url(#SvgjsRadialGradient2950)"
                                                    opacity="0.4"
                                                />
                                                <path
                                                    id="SvgjsPath2953"
                                                    d="M76.354 84c0 1.3-1.053 2.353-2.353 2.353 -1.299 0-2.354-1.053-2.354-2.353 0-1.299 1.055-2.354 2.354-2.354C75.301 81.646 76.354 82.7 76.354 84z"
                                                    fill="#4e60a3"
                                                    stroke-width="none"
                                                    opacity="1"
                                                />
                                                <path
                                                    id="SvgjsPath2954"
                                                    d="M76.354 84c0 1.3-1.053 2.353-2.353 2.353 -1.299 0-2.354-1.053-2.354-2.353 0-1.299 1.055-2.354 2.354-2.354C75.301 81.646 76.354 82.7 76.354 84z"
                                                    fill="#000000"
                                                    stroke-width="none"
                                                    opacity="0.9"
                                                />
                                                <path
                                                    id="SvgjsPath2955"
                                                    d="M70.717 86.748c0.449-0.302 1.059-0.18 1.36 0.268 0.301 0.449 0.182 1.059-0.268 1.36 -0.45 0.303-1.059 0.183-1.36-0.267C70.148 87.66 70.268 87.049 70.717 86.748L70.717 86.748z"
                                                    fill="url(#SvgjsLinearGradient2956)"
                                                    opacity="0.5"
                                                />
                                                <path
                                                    id="SvgjsPath2959"
                                                    d="M75.86 83.672c-0.251 0.374-0.969 0.331-1.606-0.096 -0.638-0.427-0.95-1.078-0.7-1.451l0-0.001c0.25-0.374 0.969-0.331 1.605 0.097C75.798 82.647 76.11 83.297 75.86 83.672 75.86 83.672 75.86 83.672 75.86 83.672z"
                                                    fill="url(#SvgjsLinearGradient2960)"
                                                    opacity="0.5"
                                                />
                                                <path
                                                    id="SvgjsPath2963"
                                                    d="M78.716 82.673c-0.568 0.873-2.036 0.925-3.275 0.117 -1.24-0.808-1.784-2.17-1.215-3.043 0.568-0.872 2.036-0.924 3.275-0.117C78.74 80.439 79.284 81.802 78.716 82.673L78.716 82.673z"
                                                    fill="url(#SvgjsLinearGradient2964)"
                                                    opacity="0.75"
                                                />
                                            </g>
                                        </g>
                                    </g>
                                    <g id="svga-group-eyesfront-left">
                                        <path
                                            id="SvgjsPath3964"
                                            d="M53.729 84.098c-0.382 3.304 9.854 22.004 20.071 22.004s19.5-5.292 19.5-22.003c0-17.789-9.283-22.001-19.5-22.001S55.626 67.704 53.729 84.098zM60.8 85.053l-0.1-4.149c1.328-3.949 19.541-4.352 25.9 1.784 1.396 3.231-0.409 5.477-3.529 6.438 -3.293-0.784-4.969 1.059-9.809 1.166 -8.057 0.177-9.938-0.618-11.199-2.638C61.54 86.816 61.04 85.726 60.8 85.053z"
                                            fill="#f0c7b1"
                                            stroke-width="none"
                                            opacity="1"
                                        />
                                        <path
                                            id="SvgjsPath3965"
                                            d="M59.698 82.412c0.023 7.534 7.646 13.604 17.038 13.566 9.389-0.043 16.985-6.179 16.961-13.713 -0.023-7.533-7.647-13.605-17.04-13.566C67.265 68.743 59.673 74.878 59.698 82.412zM60.8 85.053l-0.1-4.149c1.328-3.949 19.541-4.352 25.9 1.784 1.396 3.231-0.409 5.477-3.529 6.438 -3.293-0.784-4.969 1.059-9.809 1.166 -8.057 0.177-9.938-0.618-11.199-2.638C61.54 86.816 61.04 85.726 60.8 85.053z"
                                            fill="url(#SvgjsRadialGradient3966)"
                                            opacity="1"
                                        />
                                        <path
                                            id="SvgjsPath3970"
                                            d="M62.063 87.654c-0.523-0.837-1.023-1.928-1.264-2.601l-0.1-4.149c1.328-3.949 19.541-4.352 25.9 1.784 1.396 3.231-0.409 5.477-3.529 6.438 -3.293-0.784-4.969 1.059-9.809 1.166C65.206 90.469 63.324 89.673 62.063 87.654z"
                                            fill="url(#SvgjsRadialGradient3971)"
                                            opacity="1"
                                        />
                                        <path
                                            id="SvgjsPath3974"
                                            d="M89.465 81.193c-9.617-5.761-16.701-6.128-28.117-5.394C70.877 74.298 81.852 75.387 89.465 81.193z"
                                            fill="#c27b55"
                                            stroke-width="none"
                                            opacity="1"
                                        />
                                        <path
                                            id="SvgjsPath3975"
                                            d="M88.23 85.283c-3.24-8.315-25.943-8.364-27.431-4.181v3.895c-1.021-1.539-1.047-1.633-1.483-3.404l-2.195 0.746c0 0 2.746-3.873 5.299-4.381C84.606 73.539 88.04 83.949 88.23 85.283zM84.743 89.42c-4.625-1.98-5.94 0.378-11.563 0.495 -8.004 0.168-9.567-0.766-11.125-2.476 0.813 2.091 1.375 3.085 10.875 3.027C78.306 90.433 81.243 88.212 84.743 89.42z"
                                            fill="#000000"
                                            stroke-width="none"
                                            opacity="1"
                                        />
                                    </g>
                                </g>
                            </g>
                            <g
                                id="svga-group-eyes-right-move"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <g
                                    id="svga-group-eyes-right"
                                    transform="matrix(1,0,0,1,0,0)"
                                >
                                    <g id="svga-group-eyesback-right">
                                        <path
                                            id="SvgjsPath3947"
                                            d="M116.529 89.125c3.293-0.784 4.969 1.059 9.809 1.166 8.057 0.177 9.938-0.618 11.199-2.638 0.523-0.837 1.023-1.928 1.264-2.601l0.1-4.149c-1.328-3.949-19.541-4.352-25.9 1.784 -0.287 0.666-0.433 1.287-0.465 1.867 0.19 0.958 0.512 1.878 0.947 2.749C114.189 88.113 115.245 88.729 116.529 89.125z"
                                            fill="url(#SvgjsRadialGradient3948)"
                                            opacity="1"
                                        />
                                    </g>
                                    <g
                                        id="svga-group-eyesiriswrapper-right"
                                        transform="matrix(1,0,0,1,-0.25,0.25)"
                                    >
                                        <g
                                            id="svga-group-eyesiriscontrol-right"
                                            transform="matrix(1,0,0,1,0,0)"
                                        >
                                            <g
                                                id="svga-group-eyesiris-right"
                                                transform="matrix(1,0,0,1,0,0)"
                                            >
                                                <path
                                                    id="SvgjsPath2967"
                                                    d="M132 84c0 3.313-2.687 6-5.999 6 -3.313 0-6.001-2.687-6.001-6l0 0c0-3.314 2.688-6 6.001-6C129.313 77.999 132 80.686 132 84L132 84z"
                                                    fill="#4e60a3"
                                                    stroke-width="none"
                                                    opacity="1"
                                                />
                                                <path
                                                    id="SvgjsPath2968"
                                                    d="M125.328 78.066c-0.023 0.003-0.047 0.006-0.071 0.009 0.029 0.135 0.058 0.271 0.085 0.406C125.336 78.344 125.333 78.204 125.328 78.066zM125.341 78.48c0.069 1.972 0.185 3.729 0.518 4.364C126.033 82.148 125.735 80.414 125.341 78.48zM125.858 82.845c-0.042 0.167-0.108 0.281-0.207 0.319 -0.101 0.038-0.226-0.006-0.367-0.103 0.04 0.167 0.036 0.297-0.036 0.378 -0.072 0.081-0.201 0.101-0.372 0.078 0.112 0.13 0.171 0.249 0.146 0.353 -0.028 0.104-0.134 0.182-0.293 0.242 0.158 0.063 0.265 0.141 0.29 0.245 0.025 0.104-0.032 0.223-0.145 0.352 0.17-0.021 0.3 0.001 0.37 0.082 0.071 0.081 0.075 0.212 0.035 0.379 0.141-0.097 0.266-0.139 0.365-0.1 0.102 0.038 0.166 0.152 0.206 0.32 0.08-0.152 0.172-0.249 0.279-0.26 0.105-0.014 0.217 0.059 0.329 0.188 0.002-0.172 0.037-0.299 0.128-0.36 0.087-0.061 0.219-0.049 0.379 0.013 -0.078-0.152-0.104-0.281-0.056-0.377 0.051-0.095 0.174-0.146 0.345-0.166 -0.141-0.099-0.228-0.2-0.225-0.308 -0.001-0.108 0.084-0.209 0.227-0.306 -0.171-0.021-0.291-0.072-0.342-0.167 -0.05-0.095-0.022-0.225 0.057-0.377 -0.161 0.06-0.291 0.072-0.38 0.011s-0.124-0.188-0.125-0.36c-0.111 0.128-0.224 0.199-0.33 0.185C126.029 83.092 125.938 82.998 125.858 82.845zM126.466 82.92c0.479-0.535 1.021-2.209 1.569-4.104C127.182 80.593 126.468 82.202 126.466 82.92zM128.035 78.816c0.06-0.122 0.121-0.246 0.179-0.37 -0.021-0.007-0.042-0.017-0.063-0.026C128.112 78.553 128.074 78.686 128.035 78.816zM126.972 83.27c0.673-0.252 1.932-1.483 3.298-2.905C128.688 81.541 127.307 82.634 126.972 83.27zM130.27 80.365c0.1-0.075 0.202-0.15 0.305-0.225 -0.015-0.018-0.03-0.033-0.042-0.049C130.445 80.181 130.358 80.274 130.27 80.365zM127.255 83.814c0.713 0.088 2.399-0.417 4.271-1.041C129.578 83.081 127.848 83.406 127.255 83.814zM131.526 82.774c0.11-0.016 0.225-0.034 0.337-0.052 -0.005-0.019-0.009-0.038-0.014-0.057C131.742 82.701 131.632 82.738 131.526 82.774zM127.253 84.427c0.591 0.412 2.318 0.747 4.263 1.063C129.65 84.857 127.967 84.342 127.253 84.427zM131.516 85.49c0.095 0.033 0.19 0.067 0.285 0.098 0.005-0.017 0.009-0.033 0.013-0.05C131.716 85.523 131.614 85.507 131.516 85.49zM126.965 84.97c0.332 0.637 1.708 1.738 3.282 2.924C128.889 86.464 127.638 85.226 126.965 84.97zM130.248 87.892c0.059 0.062 0.119 0.126 0.178 0.189 0.01-0.012 0.02-0.021 0.031-0.032C130.387 87.997 130.315 87.944 130.248 87.892zM126.461 85.317c-0.003 0.719 0.702 2.331 1.547 4.113C127.468 87.533 126.937 85.855 126.461 85.317zM128.008 89.431c0.021 0.075 0.043 0.152 0.063 0.229 0.015-0.006 0.026-0.01 0.039-0.014C128.076 89.574 128.041 89.5 128.008 89.431zM125.851 85.389c-0.336 0.637-0.461 2.39-0.542 4.361C125.713 87.82 126.022 86.087 125.851 85.389zM125.309 89.75c-0.017 0.075-0.031 0.151-0.047 0.228 0.014 0.003 0.024 0.003 0.039 0.005C125.303 89.906 125.307 89.826 125.309 89.75zM125.279 85.169c-0.596 0.407-1.521 1.904-2.508 3.61C124.026 87.259 125.105 85.867 125.279 85.169zM122.771 88.779c-0.052 0.063-0.107 0.13-0.161 0.193 0.013 0.008 0.024 0.014 0.037 0.024C122.688 88.924 122.731 88.851 122.771 88.779zM124.874 84.71c-0.716 0.083-2.23 0.978-3.897 2.029C122.795 85.977 124.395 85.248 124.874 84.71zM120.977 86.741c-0.087 0.036-0.175 0.072-0.263 0.11 0.006 0.013 0.014 0.027 0.023 0.04C120.817 86.842 120.897 86.791 120.977 86.741zM124.729 84.113c-0.672-0.257-2.43-0.168-4.396-0.011C122.298 84.27 124.055 84.367 124.729 84.113zM120.333 84.102c-0.106-0.01-0.217-0.02-0.322-0.029 -0.001 0.019-0.003 0.038-0.001 0.056C120.119 84.119 120.228 84.11 120.333 84.102zM124.876 83.519c-0.474-0.539-2.069-1.277-3.882-2.051C122.653 82.528 124.163 83.432 124.876 83.519zM120.994 81.468c-0.104-0.067-0.21-0.134-0.315-0.201 -0.009 0.019-0.019 0.038-0.028 0.055C120.766 81.371 120.883 81.419 120.994 81.468zM125.284 83.061c-0.169-0.698-1.241-2.094-2.485-3.623C123.775 81.15 124.692 82.651 125.284 83.061zM122.799 79.438c-0.067-0.115-0.133-0.232-0.198-0.349 -0.019 0.013-0.039 0.026-0.057 0.039C122.629 79.231 122.716 79.335 122.799 79.438z"
                                                    fill="url(#SvgjsRadialGradient2969)"
                                                    opacity="0.7"
                                                />
                                                <path
                                                    id="SvgjsPath2972"
                                                    d="M126.886 78.086c-0.024-0.003-0.047-0.007-0.07-0.01 -0.008 0.138-0.016 0.277-0.024 0.414C126.821 78.356 126.854 78.22 126.886 78.086zM126.791 78.489c-0.443 1.922-0.787 3.649-0.63 4.35C126.511 82.211 126.671 80.459 126.791 78.489zM126.161 82.839c-0.084 0.15-0.177 0.243-0.283 0.254 -0.106 0.01-0.216-0.064-0.327-0.195 -0.004 0.171-0.042 0.297-0.133 0.356 -0.09 0.059-0.221 0.045-0.38-0.021 0.075 0.155 0.101 0.285 0.049 0.378 -0.054 0.094-0.176 0.142-0.346 0.158 0.138 0.101 0.22 0.204 0.217 0.312 -0.002 0.107-0.089 0.207-0.23 0.302 0.17 0.024 0.289 0.079 0.337 0.174 0.048 0.096 0.018 0.225-0.064 0.375 0.162-0.057 0.293-0.065 0.38-0.002 0.087 0.063 0.12 0.19 0.115 0.363 0.117-0.125 0.229-0.196 0.337-0.179 0.105 0.014 0.194 0.113 0.27 0.268 0.046-0.167 0.113-0.279 0.216-0.315 0.101-0.036 0.226 0.01 0.363 0.111 -0.035-0.167-0.028-0.299 0.045-0.378 0.072-0.079 0.204-0.096 0.375-0.072 -0.11-0.132-0.168-0.251-0.138-0.355 0.027-0.104 0.136-0.18 0.299-0.237 -0.159-0.064-0.263-0.145-0.288-0.25 -0.022-0.105 0.038-0.223 0.154-0.349 -0.172 0.016-0.302-0.006-0.37-0.088 -0.07-0.082-0.072-0.214-0.027-0.379 -0.143 0.094-0.269 0.134-0.368 0.093C126.262 83.122 126.198 83.007 126.161 82.839zM126.729 83.07c0.601-0.394 1.557-1.871 2.578-3.558C128.022 81.007 126.916 82.375 126.729 83.07zM129.307 79.511c0.089-0.102 0.18-0.206 0.269-0.311 -0.02-0.013-0.037-0.028-0.056-0.042C129.449 79.277 129.378 79.396 129.307 79.511zM127.127 83.538c0.715-0.07 2.249-0.934 3.937-1.953C129.231 82.312 127.614 83.01 127.127 83.538zM131.063 81.584c0.116-0.046 0.234-0.092 0.354-0.138 -0.01-0.021-0.021-0.04-0.028-0.059C131.281 81.453 131.173 81.52 131.063 81.584zM127.259 84.137c0.666 0.27 2.426 0.218 4.396 0.101C129.692 84.03 127.938 83.896 127.259 84.137zM131.654 84.237c0.111 0.013 0.226 0.025 0.339 0.037 0.001-0.02 0.001-0.039 0.002-0.058C131.882 84.223 131.766 84.23 131.654 84.237zM127.1 84.729c0.463 0.551 2.046 1.321 3.842 2.129C129.303 85.763 127.811 84.831 127.1 84.729zM130.941 86.858c0.082 0.057 0.167 0.114 0.25 0.168 0.009-0.015 0.018-0.03 0.024-0.045C131.126 86.942 131.032 86.9 130.941 86.858zM126.681 85.179c0.155 0.701 1.199 2.12 2.413 3.674C128.151 87.119 127.265 85.599 126.681 85.179zM129.095 88.85c0.041 0.075 0.082 0.153 0.124 0.229 0.012-0.009 0.023-0.016 0.037-0.024C129.202 88.987 129.146 88.917 129.095 88.85zM126.103 85.383c-0.188 0.693 0.076 2.433 0.43 4.373C126.502 87.784 126.424 86.026 126.103 85.383zM126.532 89.756c0.001 0.078 0.003 0.158 0.003 0.238 0.015-0.002 0.026-0.004 0.04-0.004C126.562 89.913 126.547 89.833 126.532 89.756zM125.495 85.294c-0.489 0.528-1.064 2.189-1.652 4.072C124.733 87.607 125.48 86.013 125.495 85.294zM123.843 89.366c-0.035 0.068-0.069 0.138-0.104 0.208 0.012 0.006 0.022 0.009 0.035 0.015C123.797 89.516 123.821 89.439 123.843 89.366zM125 84.934c-0.68 0.239-1.961 1.446-3.356 2.838C123.25 86.628 124.652 85.563 125 84.934zM121.644 87.772c-0.067 0.047-0.138 0.098-0.205 0.145 0.01 0.011 0.02 0.02 0.029 0.032C121.525 87.89 121.586 87.832 121.644 87.772zM124.728 84.385c-0.713-0.104-2.406 0.368-4.29 0.952C122.392 85.071 124.126 84.781 124.728 84.385zM120.438 85.339c-0.093 0.013-0.188 0.024-0.283 0.039 0.004 0.015 0.008 0.03 0.013 0.044C120.258 85.396 120.348 85.366 120.438 85.339zM124.741 83.772c-0.582-0.423-2.303-0.792-4.242-1.149C122.353 83.294 124.025 83.843 124.741 83.772zM120.499 82.623c-0.101-0.037-0.205-0.075-0.305-0.112 -0.006 0.019-0.011 0.037-0.015 0.054C120.287 82.584 120.395 82.604 120.499 82.623zM125.038 83.235c-0.318-0.643-1.669-1.769-3.22-2.986C123.147 81.704 124.372 82.968 125.038 83.235zM121.818 80.25c-0.083-0.091-0.167-0.183-0.251-0.275 -0.015 0.016-0.028 0.031-0.043 0.046C121.623 80.097 121.724 80.173 121.818 80.25zM125.551 82.899c0.017-0.718-0.656-2.344-1.464-4.142C124.588 80.663 125.085 82.35 125.551 82.899zM124.087 78.757c-0.034-0.128-0.067-0.259-0.102-0.389 -0.021 0.007-0.043 0.015-0.063 0.023C123.977 78.513 124.033 78.636 124.087 78.757z"
                                                    fill="url(#SvgjsRadialGradient2973)"
                                                    opacity="0.4"
                                                />
                                                <path
                                                    id="SvgjsPath2976"
                                                    d="M128.354 84c0 1.3-1.054 2.353-2.353 2.353 -1.3 0-2.354-1.053-2.354-2.353 0-1.299 1.055-2.354 2.354-2.354C127.302 81.646 128.354 82.7 128.354 84z"
                                                    fill="#4e60a3"
                                                    stroke-width="none"
                                                    opacity="1"
                                                />
                                                <path
                                                    id="SvgjsPath2977"
                                                    d="M128.354 84c0 1.3-1.054 2.353-2.353 2.353 -1.3 0-2.354-1.053-2.354-2.353 0-1.299 1.055-2.354 2.354-2.354C127.302 81.646 128.354 82.7 128.354 84z"
                                                    fill="#000000"
                                                    stroke-width="none"
                                                    opacity="0.9"
                                                />
                                                <path
                                                    id="SvgjsPath2978"
                                                    d="M122.718 86.748c0.448-0.302 1.059-0.18 1.359 0.268 0.302 0.449 0.183 1.059-0.268 1.36 -0.45 0.303-1.059 0.183-1.359-0.267C122.148 87.66 122.268 87.049 122.718 86.748L122.718 86.748z"
                                                    fill="url(#SvgjsLinearGradient2979)"
                                                    opacity="0.5"
                                                />
                                                <path
                                                    id="SvgjsPath2982"
                                                    d="M127.859 83.672c-0.251 0.374-0.969 0.331-1.605-0.096 -0.638-0.427-0.95-1.078-0.7-1.451l0.001-0.001c0.25-0.374 0.969-0.331 1.605 0.097C127.798 82.647 128.11 83.297 127.859 83.672 127.859 83.672 127.859 83.672 127.859 83.672z"
                                                    fill="url(#SvgjsLinearGradient2983)"
                                                    opacity="0.5"
                                                />
                                                <path
                                                    id="SvgjsPath2986"
                                                    d="M130.717 82.673c-0.569 0.873-2.036 0.925-3.276 0.117 -1.239-0.808-1.784-2.17-1.215-3.043 0.568-0.872 2.035-0.924 3.275-0.117C130.74 80.439 131.284 81.802 130.717 82.673L130.717 82.673z"
                                                    fill="url(#SvgjsLinearGradient2987)"
                                                    opacity="0.75"
                                                />
                                            </g>
                                        </g>
                                    </g>
                                    <g id="svga-group-eyesfront-right">
                                        <path
                                            id="SvgjsPath3985"
                                            d="M125.801 62.098c-10.217 0-19.5 4.212-19.5 22.001 0 16.711 9.283 22.003 19.5 22.003s19.891-18.032 20.07-22.004C146.617 67.611 136.018 62.098 125.801 62.098zM137.537 87.654c-1.261 2.02-3.143 2.815-11.199 2.638 -4.84-0.107-6.516-1.95-9.809-1.166 -3.12-0.961-4.925-3.207-3.529-6.438 6.359-6.136 24.572-5.733 25.9-1.784l-0.1 4.149C138.561 85.726 138.061 86.816 137.537 87.654z"
                                            fill="#f0c7b1"
                                            stroke-width="none"
                                            opacity="1"
                                        />
                                        <path
                                            id="SvgjsPath3986"
                                            d="M122.943 68.699c-9.393-0.04-17.016 6.033-17.039 13.566 -0.025 7.535 7.572 13.67 16.961 13.713 9.391 0.037 17.014-6.033 17.037-13.566C139.928 74.878 132.336 68.743 122.943 68.699zM137.537 87.654c-1.261 2.02-3.143 2.815-11.199 2.638 -4.84-0.107-6.516-1.95-9.809-1.166 -3.12-0.961-4.925-3.207-3.529-6.438 6.359-6.136 24.572-5.733 25.9-1.784l-0.1 4.149C138.561 85.726 138.061 86.816 137.537 87.654z"
                                            fill="url(#SvgjsRadialGradient3987)"
                                            opacity="1"
                                        />
                                        <path
                                            id="SvgjsPath3991"
                                            d="M137.537 87.654c0.523-0.837 1.023-1.928 1.264-2.601l0.1-4.149c-1.328-3.949-19.541-4.352-25.9 1.784 -1.396 3.231 0.409 5.477 3.529 6.438 3.293-0.784 4.969 1.059 9.809 1.166C134.395 90.469 136.276 89.673 137.537 87.654z"
                                            fill="url(#SvgjsRadialGradient3992)"
                                            opacity="1"
                                        />
                                        <path
                                            id="SvgjsPath3995"
                                            d="M110.136 81.193c9.617-5.761 16.701-6.128 28.117-5.394C128.724 74.298 117.749 75.387 110.136 81.193z"
                                            fill="#c27b55"
                                            stroke-width="none"
                                            opacity="1"
                                        />
                                        <path
                                            id="SvgjsPath3996"
                                            d="M137.181 77.957c2.553 0.508 5.299 4.381 5.299 4.381l-2.195-0.746c-0.437 1.771-0.463 1.865-1.483 3.404v-3.895c-1.487-4.183-24.19-4.134-27.431 4.181C111.561 83.949 114.994 73.539 137.181 77.957zM126.67 90.467c9.5 0.058 10.063-0.937 10.875-3.027 -1.558 1.71-3.121 2.644-11.125 2.476 -5.622-0.117-6.938-2.476-11.563-0.495C118.357 88.212 121.295 90.433 126.67 90.467z"
                                            fill="#000000"
                                            stroke-width="none"
                                            opacity="1"
                                        />
                                    </g>
                                </g>
                            </g>
                            <g id="svga-group-facehighlight-single">
                                <path
                                    id="SvgjsPath2903"
                                    d="M141 113.974c0.035 22.622-18.292 40.994-40.938 41.025 -22.642 0.037-41.028-18.273-41.063-40.9 -0.035-22.62 18.292-41.064 40.937-41.1C122.579 72.964 140.967 91.349 141 113.974z"
                                    fill="url(#SvgjsRadialGradient2904)"
                                    opacity="1"
                                />
                                <path
                                    id="SvgjsPath2907"
                                    d="M137.5 53.999c0 20.711-16.789 37.5-37.499 37.5 -20.711 0-37.501-16.789-37.501-37.5s16.79-37.5 37.501-37.5C120.711 16.499 137.5 33.288 137.5 53.999z"
                                    fill="url(#SvgjsRadialGradient2908)"
                                    opacity="1"
                                />
                            </g>
                            <g
                                id="svga-group-eyebrows-left-move"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <g
                                    id="svga-group-eyebrows-left-rotate"
                                    transform="matrix(1,0,0,1,0,0)"
                                >
                                    <g
                                        id="svga-group-eyebrows-left"
                                        transform="matrix(1,0,0,1,0,0)"
                                    >
                                        <path
                                            id="SvgjsPath4007"
                                            d="M54 74.189c9.954-9.974 16.761-5.915 30.589-3.264 0.845 0.162 6.32 1.539 5.31 3.469 -0.483 0.924-2.036 0.814-2.903 0.798C73.308 74.936 66.652 65.197 54 74.189z"
                                            fill="#2a232b"
                                            stroke-width="none"
                                            opacity="1"
                                        />
                                    </g>
                                </g>
                            </g>
                            <g
                                id="svga-group-eyebrows-right-move"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <g
                                    id="svga-group-eyebrows-right-rotate"
                                    transform="matrix(1,0,0,1,0,0)"
                                >
                                    <g
                                        id="svga-group-eyebrows-right"
                                        transform="matrix(1,0,0,1,0,0)"
                                    >
                                        <path
                                            id="SvgjsPath4008"
                                            d="M146 74.189c-9.953-9.974-16.761-5.915-30.589-3.264 -0.846 0.162-6.32 1.539-5.311 3.469 0.483 0.924 2.036 0.814 2.903 0.798C126.691 74.936 133.348 65.197 146 74.189z"
                                            fill="#2a232b"
                                            stroke-width="none"
                                            opacity="1"
                                        />
                                    </g>
                                </g>
                            </g>
                            <g
                                id="svga-group-nose-single-move"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <g
                                    id="svga-group-nose-single"
                                    transform="matrix(1,0,0,1,0,0)"
                                >
                                    <path
                                        id="SvgjsPath3041"
                                        d="M91.115 115.499c-0.878 2.064 5.934 4.292 8.519 4.429 2.8 0.147 10.646-2.9 9.316-4.992 -1.399-2.195-6.643-0.286-8.906-0.286C97.792 114.649 92.291 112.745 91.115 115.499z"
                                        fill="#e1ac8f"
                                        stroke-width="none"
                                        opacity="1"
                                        stroke="none"
                                    />
                                    <path
                                        id="SvgjsPath3042"
                                        d="M101.857 117.058c-0.23-0.759 1.876-1.584 2.657-1.694 1.101-0.16 3.36 0.802 3.158 1.592 -0.184 0.698-2.148-0.533-2.86-0.429C104.078 116.634 102.075 117.769 101.857 117.058zM94.974 116.811c0.968 0 2.404 0.623 2.668 0.074 0.315-0.655-2.139-1.461-2.86-1.372 -0.596 0.07-2.733 1.315-2.439 1.839C92.617 117.833 93.698 116.811 94.974 116.811z"
                                        fill="#c27b55"
                                        stroke-width="none"
                                        opacity="1"
                                        stroke="none"
                                    />
                                    <path
                                        id="SvgjsPath3043"
                                        d="M100.089 111.999c0.607 0 1.742-0.74 1.792-2.23 0.201-6.008-0.956-23.833-1.792-23.77 -0.78 0.059-2.267 17.637-1.948 23.77C98.22 111.271 99.404 111.999 100.089 111.999z"
                                        fill="#fff5ef"
                                        stroke-width="none"
                                        opacity="0.2"
                                        stroke="none"
                                    />
                                </g>
                            </g>
                            <g
                                id="svga-group-beardwrap"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <g
                                    id="svga-group-beard-single-move"
                                    transform="matrix(1,0,0,1,0,0)"
                                >
                                    <g
                                        id="svga-group-beard-single"
                                        transform="matrix(1,0,0,1,0,0)"
                                    >
                                        <path
                                            id="SvgjsPath3039"
                                            d="M100,18.13L100,18.13L100,18.13L100,18.13z"
                                            fill="#2a232b"
                                            stroke-width="none"
                                            opacity="1"
                                        />
                                    </g>
                                </g>
                            </g>
                            <g
                                id="svga-group-mustache-single-move"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <g
                                    id="svga-group-mustache-single"
                                    transform="matrix(1,0,0,1,0,0)"
                                >
                                    <path
                                        id="SvgjsPath3037"
                                        d="M100,18.13L100,18.13L100,18.13L100,18.13z"
                                        fill="#2a232b"
                                        stroke-width="none"
                                        opacity="1"
                                    />
                                </g>
                            </g>
                            <g
                                id="svga-group-hair-front"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <path
                                    id="SvgjsPath4012"
                                    d="M49.325 111.556c-5.418-3.127-9.142-6.627-12.893-15.151 -0.509-1.289-1.893-5.586-1.893-6.583 -2.19-1.805-4.608-7.14-5.665-9.781 -3.002-10.296-2.617-22.5-0.507-28.338l-0.355-0.177c-2.585 3.959-3.283 7.628-3.899 11.174 -2.751-9.066-1.237-19.367 5.766-28.261 -3.219 0.806-4.477 1.441-7.395 0.896 5.609-2.923 22.364-15.071 26.957-23.31 -3.952 1.013-8.211 3.096-11.467 5.241C42.093 4.296 58.83-6.401 72.393-5.223c-2.447-2.174-4.562-4.95-6.305-7.631 3.691 1.212 10.025 3.686 16.204 5.204 21.252 4.455 15.286 2.485 34.942-4.586 -0.811 2.912-0.804 3.07-2.543 7.203 14.207-5.614 27.89 0.23 32.18 8.219h0.009c0.062 0.115 0.122 0.232 0.182 0.348 -1.924-0.647-3.58-0.815-5.581-0.929 3.554 6.121 5.933 6.694 17.512 10.142 1.198 0.376 3.149 0.87 4.78 1.156 -2.419 1.728-4.111 2.16-7.047 2.539 4.662 1.984 7.377 5.559 9.431 10.264 2.974 7.095 3.489 12.801 2.96 19.332 -1.288-1.974-3.025-4.896-4.785-7.3l-0.343 0.202c4.382 9.461 2.86 17.286 19.494 28.646 -1.435 0.321-3.059 0.489-4.729 0.489l0 0c-2.914 0-5.43-0.476-7.888-1.295 0.702 8.681 0.171 12.925-0.7 16.66 -2.029 7.642-6.055 13.108-13.631 14.948 -4.42 5.776-8.943 8.17-12.081 8.709 2.207-3.648 7.364-13.608 8.248-17.532l-0.418-0.743c-9.509-2.35-16.209-9.562-17.565-19.881 -1.947 2.924-3.769 5.106-9.482 9.489 -0.465-11.558-6.145-26.409-13.25-35.719 -0.038 3.226 0.066 3.476 0.888 7.833h0.007c1.052 5.11 4.22 11.59 5.277 14.718 -3.106-1.771-5.685-2.961-9.079-8.315 -1.651-2.597-3.648-6.999-4.548-10.02l-0.39 0.033c-0.232 1.911-0.205 3.113-0.191 3.758 0 2.133 2.814 12.875 4.655 15.999 -6.57-3.309-9.514-8.744-11.7-14.128l-0.385 0.063c-0.212 3.309 0.151 10.703 1.586 16.32 -5.281-1.591-8.449-3.893-11.229-8.137 -1.839-3.446-1.922-4.927-2.316-8.32 -5.93 7.875-15.644 14.488-22.28 16.559 -0.031 0.009-0.094 0.027-0.169 0.048 0.9-1.781 1.845-3.528 2.76-5.222 2.511-4.645 3.927-7.333 5.656-11.639C54.489 63.345 51.333 80.329 55.478 99.135c-2.798-1.794-3.247-2.156-5.58-4.629 0.542 3.657 0.365 9.122-1.793 14.192l-0.033 0.078 0.033 0.078C49.309 111.692 48.909 110.896 49.325 111.556z"
                                    fill="#3b3128"
                                    stroke-width="none"
                                    opacity="1"
                                />
                                <path
                                    id="SvgjsPath4013"
                                    d="M125.204 77.964c-0.578-11.19-5.923-25.294-12.679-34.51C126.567 47.285 130.275 69.622 125.204 77.964zM106.011 36.392c-3.612 7.222-0.428 21.701 12.146 28.871C112.525 58.574 107.619 51.859 106.011 36.392zM108.453 66.433c-7.192-8.037-10.356-19.174-10.347-29.233 -3.515 6.254-2.14 23.155 10.499 29.518C108.556 66.635 108.504 66.526 108.453 66.433zM89 37c-4.366 7.103-9.458 26.381 9.106 31.973C87.048 59.856 87 49.904 89 37zM62.11 69.123c0.075-0.021 0.138-0.04 0.169-0.048 6.428-2.005 16.639-9.568 22.606-17.115 0.386-2.524 0.36-4.479 0.876-6.959C81.137 53.507 67.663 65.263 62.11 69.123zM52.691 89.147C45.784 78.324 51.501 57.719 54 55.575 49.975 58.052 41.291 80.894 52.691 89.147zM163.003 71.547c-0.902 15.205-9.329 25.748-18.371 35.513C154.984 105.083 166.035 88.224 163.003 71.547zM124.746 13.008C139.146 20.948 142.804 24.918 148 43 148 29.963 140.027 11.987 124.746 13.008zM109.744 10c-3.342 13.6 2.781 23 12.857 27.2C115.994 30.985 109.445 19.687 109.744 10zM35.291 56.683C42.033 57.062 52.027 53.314 54 45 49.325 51.209 45.258 54.686 35.291 56.683zM118.932 6.5c14.625-5.633 24.125-4.452 28.129-2.966C143.588 1.305 129.869-2.515 118.932 6.5zM38.819 16.035c10.126-6.212 14.655-5.279 20.253-5.606C51.421 7.273 45.744 9.378 38.819 16.035zM138.423 9.041c10.748 6.188 12.979 9.687 25.349 4.862C157 16.162 148 13.815 138.423 9.041zM86.739 6.456C92.978 6.459 96.974 8.788 100 11.063 98.35 8.073 91.713 3.969 86.739 6.456zM143.806 47.319c-1.848 11.267 5.017 16.082 14.445 17.591C152.279 63.099 145.654 56.831 143.806 47.319zM60.555 44.103c8.802-4.429 20.361-14.742 20.361-24.204C76.744 28.11 70.447 37 60.555 44.103zM183.241 67.417C171.046 68.508 164.456 58.388 157 50c2.801 7.468 8.217 12.322 14.619 17.002 2.223 0.672 4.515 1.073 7.134 1.073 1.67 0 3.294-0.168 4.729-0.489C183.398 67.529 183.323 67.474 183.241 67.417zM37.509 67.144c-3.62 12.01-6.057 30.855 11.816 44.412C39.134 100 35.743 81.271 37.509 67.144zM84.497 11.687C72.32 11.938 62.5 13 56.397 28.11 69.522 15.608 75.298 14.736 84.497 11.687zM24.119 57.719c1.73-6.653 6.276-11.247 13.078-13.775C28.606 44.103 25.479 48.186 24.119 57.719zM137.83 59.037c-6.883 10.962 0.74 24.952 14.349 29.395C138.508 74.348 138.111 70.642 137.83 59.037zM168.885 45.242C166.06 33 160.582 26.235 152.279 30.94 160.87 28.11 162.762 37.2 168.885 45.242zM131.446 71.73c10.059-10.14 6.667-25.225-1.631-31.637C136.373 53.445 134.794 60.709 131.446 71.73z"
                                    fill="#2c2219"
                                    stroke-width="none"
                                    opacity="1"
                                />
                                <path
                                    id="SvgjsPath4014"
                                    d="M110.203 28.735c-7.752-5.34-11.439-9.634-17-16.667C98.507 16.871 105.104 23.542 110.203 28.735zM123.869 23.402c12.675 2.771 10.384 1.424 18.667 9.333C136.584 24.215 134.941 23.956 123.869 23.402zM127.869 33.402c7.079 3.301 11.655 15.926 13 23.333C140.952 47.935 136.387 35.737 127.869 33.402zM140.203 60.735c-0.438 8.567 3.08 11.935 7.333 21.667C145.451 73.278 141.402 70.29 140.203 60.735zM158.869 68.069c-0.707 8.421 0.23 14.627-3.666 21.333C160.468 83.167 159.616 76.161 158.869 68.069zM167.869 67.735c2.15 5.972-0.532 17.421-3.666 22.667C169.216 84.525 171.429 74.01 167.869 67.735zM152.869 33.735c11.648 2.03 4.693 18.159 19.334 27.333C159.416 48.888 165.243 33.55 152.869 33.735zM146.536 19.402c10.708 1.315 15.663 5.39 19.667 14C163.707 23.215 156.576 18.773 146.536 19.402zM115.203 41.069c9.562 6.386 13.174 17.608 13.333 29C130.82 58.701 126.871 45.731 115.203 41.069zM114.869-1.265c13.246-1.465 13.697-1.931 22.334 0.333C131.115-4.134 126.459-5.081 114.869-1.265zM74.536-7.265c9.174 6.781 29.321 12.629 37.667-1C103.296 1.777 86.568-1.323 74.536-7.265zM91.869 4.402c5.054-0.75 7.943 0.543 13.334 7.667C102.484 5.991 98.11 2.087 91.869 4.402zM82.536 8.402c-8.516-0.987-16.124-0.718-19.667 8.333C67.811 9.291 72.223 9.411 82.536 8.402zM47.869 8.069c4.683-4.046 14.198-10.146 22.333-9C62.43-3.799 52.913 1.43 47.869 8.069zM34.869 29.735c8.239-2.621 16.719-6.773 20.667-14.333C50.845 21.033 43.314 24.832 34.869 29.735zM49.869 29.069c-1.195 12.697-8.067 16.114-14 25.667C45.636 44.918 51.179 40.519 49.869 29.069zM68.536 47.069c-12.292 1.269-17.363 18.449-16.667 30.667C53.818 66.438 57.941 50.561 68.536 47.069zM75.203 39.735c-1.015 7.647-1.94 11.476-5.333 21C74.771 52.952 75.721 46.942 75.203 39.735zM96.536 35.735c-2.42 8.248-4.131 16.801-0.667 24.667C94.356 53.021 95.625 47.431 96.536 35.735zM87.869 15.402c-2.639 10.946-4.018 15.103-9 22.333C85.645 31.291 87.549 25.039 87.869 15.402zM105.203 33.735c-4.181 6.509-4.464 12.145-2.667 19.667C102.38 45.491 102.472 40.92 105.203 33.735zM110.869 36.402c-2.494 6.409-2.027 11.348 0.667 16.667C110.088 47.593 109.679 44.197 110.869 36.402zM48.869 56.735c-5.414 5.987-4.846 14.654-4 22.667C45.896 70.017 45.069 63.265 48.869 56.735zM40.203 64.069c-2.677 7.568-3.156 17.894 1.333 25C38.938 81.959 39.361 71.135 40.203 64.069zM32.869 48.069c-4.311 9.962-5.28 17.968-0.667 30.333C30.584 67.67 30.145 61.234 32.869 48.069zM26.203 48.069C37.259 30.471 44.045 36.17 48.536 27.402 41.92 35.084 33 29.641 26.203 48.069zM72.203 19.402c0.119 6.162-2.69 10.826-5 17.667C70.522 31.503 73.658 25.68 72.203 19.402zM139.869 4.402c2.816 5.948 9.814 9.055 16 9C150.963 12.386 143.511 9.186 139.869 4.402zM145.536 46.735c-0.258 5.394 3.563 10.916 8 13.667C150.647 57.794 146.327 51.645 145.536 46.735z"
                                    fill="#4a423a"
                                    stroke-width="none"
                                    opacity="1"
                                />
                                <path
                                    id="SvgjsPath4015"
                                    d="M183.969 67.675c-6.263-4.256-7.33-5.468-10.979-9.56 0 0-0.13-0.15-0.36-0.41 -6.695-9.373-4.181-9.611-8.46-18.85 1.892 2.585 3.736 5.738 5.101 7.78 0.21-3.013 1.227-10.089-2.931-20.01 -1.825-4.18-4.68-8.3-8.859-10.08 4.107-0.531 5.81-2.099 6.81-2.76 -1.729-0.267-3.954-0.827-5.24-1.23 -11.193-3.341-13.854-3.955-17.21-9.73 2.593 0.148 4.093 0.503 5.62 1.06 -0.14-0.29-0.3-0.6-0.46-0.9h-0.01c-1.685-3.134-5.694-6.731-10.811-8.71 -6.66-2.164-13.447-2.699-21.119 0.33 1.653-3.92 1.639-4.2 2.47-7.16 -20.085 7.173-13.869 9.179-35.19 4.71 -6.461-1.587-13.197-4.26-16.72-5.37 1.142 1.815 3.804 5.62 6.19 7.74 -12.222-1.064-30.117 9.186-34.19 23.22 3.924-2.671 8.58-4.681 11.42-5.41 -4.303 7.714-21.63 20.432-27.16 23.08 3.367 0.755 4.777 0.036 7.48-0.64 -5.514 7-8.194 16.316-5.92 26.15 0 0.01 0 0.01 0 0.01 0.251 1.066 0.398 1.582 0.73 2.61 0.655-3.762 1.25-7.683 4.01-11.91 -1.983 5.486-2.645 17.666 0.51 28.48 1.14 2.849 3.531 8.031 5.65 9.8 0 0.398 0.873 3.943 1.91 6.57 3.745 8.508 7.459 12.167 13.64 15.62 -1.071-1.842-0.152 0.086-1.6-3.33 1.533-3.602 2.02-6.65 2.02-10.25 0.024-1.064-0.082-3.162-0.12-3.42 2.12 2.249 2.849 2.704 5.59 4.46 -6.552-28.9 6.73-41.52 14.314-46.761 -2.402 5.989-5.563 11.027-8.364 16.631 0.16-0.041 0.52-0.145 0.6-0.17 0 0 0 0 0.01 0 7.426-2.316 17.112-9.638 22.08-16.23 0.347 2.986 0.478 4.515 2.29 7.91 2.991 4.564 6.373 6.777 11.68 8.32 -1.555-5.824-1.87-13.481-1.67-16.6 2.399 5.909 5.43 11.094 12.06 14.34h0.01c0.14 0.07 0.29 0.14 0.42 0.21 -1.721-1.734-5.06-14.067-5.06-16.5 -0.016-0.705-0.036-1.87 0.189-3.73 0.945 3.177 2.972 7.555 4.57 10.07 3.576 5.639 6.229 6.686 9.6 8.64 -1.11-3.542-3.387-7.564-5.149-14.01 -0.221-0.8-0.311-1.34-0.32-1.34 -0.69-3.673-0.889-4.392-0.86-7.05 6.238 8.171 12.493 23.175 12.87 35.53 3.443-2.632 6.896-5.363 9.54-9.33 1.357 10.283 8.577 17.26 17.561 19.5 0.109 0.2 0.229 0.4 0.34 0.6 -0.824 3.688-6.054 13.94-8.43 17.76 3.147-0.36 7.957-2.755 12.59-8.79 7.616-1.846 11.667-7.385 13.71-15.08 0.768-3.291 1.446-7.654 0.729-16.42C175.681 68.596 180.602 68.525 183.969 67.675zM50.089 93.835c-0.188-2.277-0.54-4.608-1.04-6.9 0.877 1 1.603 1.796 3.63 3.4 0.161 2.242 0.458 4.618 0.96 6.97C52.639 96.433 51.013 95.237 50.089 93.835zM150.459 80.585c1.277 2.101 2.995 3.706 2.311 7.61C152.291 87.195 151.248 84.205 150.459 80.585zM170.52 66.825c-0.455 12.426-1.084 26.441-13.381 31.09 7.956-11.178 5.978-16.145 6.301-22.76 -0.814 4.577-0.103 1.329-0.99 8.41 -1.297 6.64-8.454 19.527-16.7 22.81 0.611-0.858 1.893-2.938 2.71-4.229 4.354-7.071 5.899-11.333 6.04-16.21 -0.02-0.34-0.06-0.54-0.06-0.54 -0.336-2.668-2.538-5.358-4.44-7.26 -0.239-1.495-1.114-7.706-1.52-14.28 -0.269 3.7-0.338 8.969 0.199 13l0.011 0.01c0.862 5.889 2.244 10.208 3.029 11.28 -1.551-0.623-1.77-0.781-2.77-1.32 -8.722-4.82-11.62-9.872-13.46-18.88 1.596-2.724 1.738-4.376 2.22-6.48 0-0.01 0-0.01 0-0.02 0.514-1.567-0.56-9.591-0.56-10.61 0-0.12 0.02-0.2 0.029-0.22 -0.085 0.087-0.096 0.808-0.1 0.93 -0.229 7.18 0.566 9.475-2.78 16.01 -0.279 0.45-0.52 0.96-0.85 1.42 -2.167 2.786-2.007 2.823-7.78 8.24 0.679-11.247-5.389-26.989-13.479-34.75 0.11-3.74-0.079-4.97-0.681-5.97 0.706 1.733 0.238 3.75 0 5.96 -0.573 4.723 0.177 11.666 5.37 21.61 -6.189-4.771-10.123-12.717-12.12-20.04 0.563-3.521 0.906-4.625 1.38-8.68 -1.36 5.964-3.1 9.308-3.1 15.4 0.134 3.435 2.431 11.041 4.84 15.03 -4.119-2.958-8.768-9.078-10.95-16.89 0.597-7.936 1.488-12.376 2.14-16.61 -3.518 11.411-3.571 15.709-3.85 20.82 -0.02 1.28 0.01 2.57 0.01 3.53 0.01 0.48 0.01 0.88 0.02 1.17 0.03 0.28 0.04 0.44 0.04 0.44 0.545 5.442 1.496 8.688 2.04 10.04 -4.951-2.176-9.931-6.937-11.1-12.87 -1.616-7.53 2.373-17.62 2.68-18.62 -0.853 1.706-4.395 7.961-4.51 14.97 -2.026 2.257-4.629 4.75-5.63 5.64 -5.605 5.083-10.98 8.705-15.96 11.19 0.13-0.2 0.27-0.42 0.41-0.64l-0.01 0.03c6.144-9.044 9.965-16.674 10.18-27.55 -0.58 4.238-1.601 7.9-2.866 11.256 -10.46 5.48-18.753 18.57-17.924 37.234 -0.15-0.17-0.31-0.33-0.47-0.5 -7.064-6.96-4.696-14.295-2.67-22.49 2.321-9.233 3.71-9.51 4.71-10.51 -3.46 2.069-5.596 8.819-6.82 12.85 -2.729 8.793-1.479 13.522 0.28 16.65 1.366 9.164 2.228 14.714 0.21 22.79 -1.216-2.735-2.888-9.783-3.12-13.34 -0.673-5.966-0.763-7.961-1.25-15.26 -0.494 7.405-1.295 20.041 3.62 29.87 -10.349-9.856-14.864-24.953-9.27-42.86 -3.354 7.285-4.874 13.868-3.84 21.76 -6.401-11.16-7.021-26.98-4.14-38.48 2.612-3.149 5.684-4.568 7.68-5.57 -6.141 2.238-7.106 3.404-9.64 6.19 -1.762 2.461-2.938 4.705-3.84 8.12 -0.536-8.169 1.545-16.16 7.4-23.97 5.653-1.508 10.804-4.672 15.4-8.12 -6.775 3.736-10.945 5.852-17.88 7.81 -0.886 0.262-3.403 1.002-4.34 1.12 7.457-3.866 21.268-13.739 25.05-22.81 3.97-1.186 6.349-1.333 9.04-1.66 -7.141 0-12.19 0.606-19.89 5.53 4.617-9.06 19.642-20.74 33.96-20.74 2.847 2.213 6.718 3.623 10.19 5.6 -2.169-1.853-7.413-4.64-9.28-6.11 0-0.01 0-0.01-0.01 0 -1.191-0.95-1.73-0.982-5.89-6.27 9.406 4.473 12.744 5.31 16.57 6.2 18.733 4.262 17.219 0.998 31.89-5.82 -0.354 1.012-2.504 6.973-3.28 7.73 -2.076 3.669-4.594 6.552-8.51 8.51 4.48-1.485 7.663-4.723 9.87-9.01 0.65-0.325 4.727-1.365 6.37-1.54 8.218-0.886 11.799-0.144 17.64 2.5 1 0.555 4.702 2.439 7.261 5.41 -6.718-2.101-17.275 0.695-23.921 2.92 1.711-0.326 10.455-2.156 15.62-2.54 1.891-0.16 3.761-0.08 3.761-0.09 0.09 0 0.18 0.01 0.27 0.01 2.622 5.451 4.2 7.416 17.53 10.66 1.372 0.318 2.838 0.494 3.83 0.62 -2.315 1.026-3.594 1.278-6.32 1.51 -10.533 0.214-12.152-4.801-18.6-6.76 6.802 3.031 6.574 7.8 18.97 7.8 3.643 1.355 6.84 6.796 8.439 10.49 2.288 5.485 3.317 11.582 3.57 17.52 -1.612-2.944-7.708-12.381-11.07-13.57 -0.761-0.297-1.4-0.304-2.14-0.23 2.067 0 3.499 1.242 4.71 2.93h0.01c2.547 3.711 3.938 9.101 5.25 13.6 0 0 0.061 0.2 0.16 0.54 2.532 8.814 8.096 15.083 15.771 19.33 -16.134 0.714-17.671-9.528-25.601-18.32C160.412 55.189 162.752 63.528 170.52 66.825zM157.229 63.575c-2.577-6.236-1.016-3.791-4.221-10.15 3.521 4.422 3.78 7.85 5.73 11.77 -7.248-1.936-14.8-9.364-15-17.58 -0.04-0.78-0.061-1.26-0.061-1.26C145.099 54.866 149.964 59.968 157.229 63.575zM148.549 46.706c-1.18-3.591-8.053-17.584-14.279-19.61 -1.982-0.853-4.928-1.363-7.24-1.91 8.267 0.722 12.23 0.498 18.76 12.86 0.59 1.14 1.18 2.43 1.75 3.76 -1.69-13.577-6.567-20.283-12.76-25.08 -4.292-2.865-7.618-3.228-10.29-3.68 2.949 0.081 6.466 0.083 11 2.59 4.633 2.963 7.719 6.044 10.82 13.87 0.22 0.52 0.369 0.97 0.46 1.29 0.1 0.31 0.159 0.49 0.159 0.49C148.623 36.71 148.718 40.973 148.549 46.706zM120.699 36.115c-6.086-6.25-11.09-14.396-10.61-23.07 0.697 9.229 7.345 18.064 13.82 25.01 -12.517-1.666-21.022-10.063-28.2-19.91C106.407 29.942 113.476 33.58 120.699 36.115zM87.299 5.875c-0.01 0.01-0.01 0.02-0.02 0.03 3.177-1.248 9.33-0.122 12.08 4.32 -2.801-3.547-8.862-5.14-12.62-3.77 1.205-3.917 6.946-4.981 10.93-4.42 -2.532 0-6.33 0.606-8.54 2.03C88.107 4.701 87.909 5.095 87.299 5.875zM58.909 45.555c5.625-8.431 4.559-4.042 8.75-15.7 0.465-1.342 1.924-5.56 2.9-7.75 -0.02 0.1-0.14 0.53-0.32 1.19 -3.206 12.822-4.09 14.826-8.8 20.32 8.872-5.32 14.373-10.241 19-19.54C77.348 34.462 68.579 41.758 58.909 45.555zM55.719 28.795c0 0 0 0 0-0.01 0-12.914 7.494-26.534 19.37-25.05 -13.802 0-18.42 19.599-18.42 23.9 6.221-7.458 17.108-13.956 28.27-15.99 -9.501 2.929-21.763 9.859-29.23 17.88C55.719 29.285 55.719 29.035 55.719 28.795zM36.039 56.555c6.452 0.207 12.076-2.905 16.42-7.61 -3.988 6.273-12.402 9.888-18.82 7.76 9.583-3.201 16.521-12.126 18.58-22.2 -0.775 9.675-5.943 17.08-14.12 21.24C36.345 56.557 37.039 56.126 36.039 56.555z"
                                    fill="#0d0905"
                                    stroke-width="none"
                                    opacity="1"
                                />
                            </g>
                            <g
                                id="svga-group-glasses-single-move"
                                transform="matrix(1,0,0,1,0,0)"
                            >
                                <g
                                    id="svga-group-glasses-single"
                                    transform="matrix(1,0,0,1,0,0)"
                                >
                                    <path
                                        id="SvgjsPath3030"
                                        d="M100,18.13L100,18.13L100,18.13L100,18.13z"
                                        fill="#26120b"
                                        stroke-width="none"
                                        opacity="1"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        <div class="info-main d-flex">
            <div class="info-box">
                <h2>基本資訊</h2>
                <ul>
                    <li>最高學歷 : 醒吾科技大學</li>
                    <li>工作總年資 : 3年 [ 網頁,平面,前端工程師 ]</li>
                    <li>工作狀態 : 在職中</li>
                    <li>年齡 : 29</li>
                    <li>興趣 : 桌遊 [ 對戰類, 博弈類 ] , 日文 , 音樂</li>
                </ul>
            </div>
            <div class="info-content d-flex flex-column align-items-center">
                <table-component></table-component>
                <div class="info-option">
                    <div class="d-flex">
                        <h2>外觀調整</h2>
                        <h2 class="w-100">給訪客的話</h2>
                    </div>
                    <div class="d-flex">
                        <div
                            class="info-option-wrap d-flex flex-column justify-item-center"
                        >
                            <button-component
                                :propsWidth="'100%'"
                                :propsHeight="'100px'"
                            >
                                <template v-slot:text>
                                    <div
                                        class="d-flex align-items-center option-box"
                                    >
                                        <div>
                                            髮色 :
                                        </div>
                                        <div
                                            class="origin-option color-option"
                                            data-color="#3b3128"
                                            data-id="SvgjsPath4012"
                                            @click="colorHandler"
                                        ></div>
                                        <div
                                            class="black-option  color-option"
                                            data-color="#000"
                                            data-id="SvgjsPath4012"
                                            @click="colorHandler"
                                        ></div>
                                        <div
                                            class="white-option  color-option"
                                            data-color="#fff"
                                            data-id="SvgjsPath4012"
                                            @click="colorHandler"
                                        ></div>
                                        <div
                                            class="red-option  color-option"
                                            data-color="#7d2528"
                                            data-id="SvgjsPath4012"
                                            @click="colorHandler"
                                        ></div>
                                    </div>
                                </template>
                            </button-component>
                            <button-component
                                :propsWidth="'100%'"
                                :propsHeight="'100px'"
                            >
                                <template v-slot:text>
                                    <div
                                        class="d-flex align-items-center option-box"
                                    >
                                        <div>
                                            髮根 :
                                        </div>
                                        <div
                                            class="origin-option color-option"
                                            data-color="#3b3128"
                                            data-id="SvgjsPath4015"
                                            @click="colorHandler"
                                        ></div>
                                        <div
                                            class="black-option  color-option"
                                            data-color="#000"
                                            data-id="SvgjsPath4015"
                                            @click="colorHandler"
                                        ></div>
                                        <div
                                            class="white-option  color-option"
                                            data-color="#fff"
                                            data-id="SvgjsPath4015"
                                            @click="colorHandler"
                                        ></div>
                                        <div
                                            class="red-option  color-option"
                                            data-color="#7d2528"
                                            data-id="SvgjsPath4015"
                                            @click="colorHandler"
                                        ></div>
                                    </div>
                                </template>
                            </button-component>
                            <button-component
                                :propsWidth="'100%'"
                                :propsHeight="'100px'"
                            >
                                <template v-slot:text>
                                    <div
                                        class="d-flex align-items-center option-box"
                                    >
                                        <div>
                                            衣服 :
                                        </div>
                                        <div
                                            class="origin-option color-option"
                                            data-color="#3b3128"
                                            data-id="SvgjsPath3934"
                                            @click="colorHandler"
                                        ></div>
                                        <div
                                            class="black-option  color-option"
                                            data-color="#000"
                                            data-id="SvgjsPath3934"
                                            @click="colorHandler"
                                        ></div>
                                        <div
                                            class="white-option  color-option"
                                            data-color="#fff"
                                            data-id="SvgjsPath3934"
                                            @click="colorHandler"
                                        ></div>
                                        <div
                                            class="red-option  color-option"
                                            data-color="#7d2528"
                                            data-id="SvgjsPath3934"
                                            @click="colorHandler"
                                        ></div>
                                    </div>
                                </template>
                            </button-component>
                            <button-component
                                :propsWidth="'100%'"
                                :propsHeight="'100px'"
                            >
                                <template v-slot:text>
                                    <div
                                        class="d-flex align-items-center option-box"
                                    >
                                        <div>
                                            領帶 :
                                        </div>
                                        <div
                                            class="origin-option color-option"
                                            data-color="#3b3128"
                                            data-id="SvgjsPath3929"
                                            @click="colorHandler"
                                        ></div>
                                        <div
                                            class="black-option  color-option"
                                            data-color="#000"
                                            data-id="SvgjsPath3929"
                                            @click="colorHandler"
                                        ></div>
                                        <div
                                            class="white-option  color-option"
                                            data-color="#fff"
                                            data-id="SvgjsPath3929"
                                            @click="colorHandler"
                                        ></div>
                                        <div
                                            class="red-option  color-option"
                                            data-color="#7d2528"
                                            data-id="SvgjsPath3929"
                                            @click="colorHandler"
                                        ></div>
                                    </div>
                                </template>
                            </button-component>
                        </div>
                        <div class="w-100 disign-idea">
                            建議使用電腦版來觀看此作品，仿造一個2077介面，網站的評分機制均是個人主觀標準，如果您認同我的作品或是對於小弟我有興趣，麻煩請您與我聯絡，進一步的互相認識，希望未來能夠為貴公司盡一份心力，謝謝您的耐心。
                            <p>email:z27089433@gmail.com</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Table from '@/components/Table'
import Button from '@/components/Button'
export default {
    name: 'info',
    components: {
        'table-component': Table,
        'button-component': Button,
    },
    data() {
        return {}
    },
    mounted() {
        let _this = this
        this.$nextTick(() => {
            window.addEventListener('mousemove', _this.svgHandler)
        })
    },
    methods: {
        colorHandler(e) {
            let color = e.target.dataset.color
            let dom = document.getElementById(e.target.dataset.id)
            dom.setAttribute('fill', color)
        },
        svgHandler(event) {
            const SVGDDOM = document.getElementById('svga-group-head')
            if (event.pageX > document.documentElement.offsetWidth / 2) {
                SVGDDOM.setAttribute('transform', 'rotate(10 120 120)')
            } else {
                SVGDDOM.setAttribute('transform', 'rotate(0 120 140)')
            }
        },
    },
    destroyed() {
        let _this = this
        window.removeEventListener('mousemove', _this.svgHandler)
    },
}
</script>

<style lang="scss">
@import '@/assets/scss/_utils';
.info {
    @include light-primary();
    @include com-width {
        .info-main {
            display: block;
        }
    }
    #svgP {
        @include psa(initial, initial, 0, initial);
        @include com-width {
            display: none;
        }
    }
    h2 {
        text-align: center;
        @include font(20px, 36px);
        @include com-width {
            @include font(18px);
        }
        border-bottom: 1px solid $primary;
    }
    .info-box {
        flex: 0 0 600px;
        width: 600px;
        padding: 10px 0;
        max-height: 250px;
        margin-top: 30px;

        clip-path: polygon(
            5% 0%,
            95% 0%,
            100% 10%,
            100% 90%,
            95% 100%,
            5% 100%,
            0% 90%,
            0% 10%
        );

        li {
            @include font(16px, 30px);
            text-indent: 2em;
            @include com-width {
                @include font(14px, 24px);
            }
        }
        @include com-width {
            width: 100%;
        }
    }
    .info-content {
        width: 100%;
        min-height: calc(100vh - 120px);
        margin-top: 30px;
        margin-left: 10px;

        border: 1px solid $primary;
        @include com-width {
            margin-top: 10px;
            margin-left: 0px;
            min-height: 580px;
        }
    }
    .info-option {
        width: 100%;
        h2 {
            width: 50%;
            border-left: 1px solid $primary;
        }
        @include com-width {
            h2:first-child {
                display: none;
            }
            h2 {
                width: 100%;
            }
        }
        .info-option-wrap {
            width: 50%;
            @include com-width {
                display: none;
            }
        }
    }
    .button-component {
        margin-top: 15px;
    }
    .color-option {
        width: 30px;
        height: 30px;
        margin-left: 10px;
        cursor: pointer;
    }
    .origin-option {
        background-color: #3b3128;
    }
    .black-option {
        background-color: $dark;
    }
    .white-option {
        background-color: $light;
    }
    .red-option {
        background-color: $primary;
    }
    .button-component {
        @include light-primary();
    }
    .disign-idea {
        @include font(18px, 30px);
        padding-left: 10px;
        padding-top: 10px;
        text-indent: 2em;
        p {
            text-indent: 0;
        }
        @include com-width {
            @include font(16px, 24px);
        }
    }
}


</style>
<style src="./dark.scss" lang="scss"></style>
<style src="./light.scss" lang="scss"></style>
